import {
  Alert,
  Autocomplete,
  Avatar,
  AvatarGroup,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Checkbox,
  Chip,
  CircularProgress,
  Divider,
  Drawer,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  LinearProgress,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import React, {
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState
} from 'react';
import {
  GenerateCarrierEProSeries,
  GetCarrierEProSeries,
  GetCarrierProSeriesStatus,
  GetCarriers,
  ImportCarrierEProSeries,
  UpdateCarrier,
  UpdateCarrierClaimSettings,
  UpdateCarrierDetails,
  UpdateCarrierInvoiceAuditThreshold,
  UpdateCarrierProSeries,
  UpdateCarrierRateQuoteSettings,
  UpdateCarrierSurcharge,
  UpdateCarrierThirdPartyInfo
} from '../../apis/Agency';
import { useSelector } from 'react-redux';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import ClearIcon from '@mui/icons-material/Clear';
import SortIcon from '@mui/icons-material/Sort';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CreateCarrier from './CreateCarrier';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import './Carriers.css';
import { GetCarrierDetails } from '../../apis/Agency';
import { ErrorToast, successToast } from '../../components/Toasts';
import { ToastContainer, useToast } from 'react-toastify';
import SettingsIcon from '@mui/icons-material/Settings';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import {
  MaterialReactTable,
  MRT_FullScreenToggleButton,
  MRT_ShowHideColumnsButton,
  MRT_ToggleDensePaddingButton,
  MRT_ToggleFiltersButton,
  MRT_ToggleGlobalFilterButton
} from 'material-react-table';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { GarageOutlined, TroubleshootOutlined } from '@mui/icons-material';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import NoLogo from '../../assets/carrier logos/No Logo.png';
import { multiSectionDigitalClockClasses } from '@mui/x-date-pickers';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { MetaTags } from 'react-meta-tags';
import { base_logo_url, base_url } from '../../apis/constants';
import { useIsMobile } from '../../components/IsMobileHook/IsMobileHook';
import { Col, Row } from 'reactstrap';
import { formatPhoneNumber } from '../../apis/Utils';
import NumbersIcon from '@mui/icons-material/Numbers';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CarrierReadOnlyView from './CarrierDetailsView';

// ─── Sidebar nav items ────────────────────────────────────────────────────────
const SIDEBAR_NAV = [
  {
    id: 'operations',
    label: 'Operations',
    sublabels: ['PRO Numbers', 'Surcharge', 'Threshold'],
    description: 'Series, surcharge & invoice audit settings',
    icon: (
      <svg
        width='15'
        height='15'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      >
        <line x1='4' y1='9' x2='20' y2='9' />
        <line x1='4' y1='15' x2='20' y2='15' />
        <line x1='10' y1='3' x2='8' y2='21' />
        <line x1='16' y1='3' x2='14' y2='21' />
      </svg>
    )
  },
  {
    id: 'account',
    label: 'Account & Contact',
    sublabels: ['3rd Party', 'Claims'],
    description: 'External accounts and claim contacts',
    icon: (
      <svg
        width='15'
        height='15'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      >
        <path d='M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2' />
        <circle cx='9' cy='7' r='4' />
        <path d='M23 21v-2a4 4 0 0 0-3-3.87' />
        <path d='M16 3.13a4 4 0 0 1 0 7.75' />
      </svg>
    )
  },
  {
    id: 'rates',
    label: 'Rate Rules',
    sublabels: ['Quote Settings'],
    description: 'Configure rate fetching & filtering logic',
    icon: (
      <svg
        width='15'
        height='15'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      >
        <polyline points='23 6 13.5 15.5 8.5 10.5 1 18' />
        <polyline points='17 6 23 6 23 12' />
      </svg>
    )
  }
];

function FieldLabel({ label, required }) {
  return (
    <Typography
      variant='caption'
      sx={{
        fontWeight: 500,
        fontSize: 11.5,
        color: 'text.secondary',
        mb: 0.4,
        display: 'block'
      }}
    >
      {label}
      {required && <span style={{ color: '#D4537E', marginLeft: 2 }}>*</span>}
    </Typography>
  );
}

const inputSx = {
  '& .MuiInputBase-root': { fontSize: 13, borderRadius: '8px' }
};

// ─── Sidebar drawer shared styles — Teal Emerald theme ────────────────────────
const sidebarStyles = {
  drawerWidth: 820,
  sidebar: {
    width: 210,
    flexShrink: 0,
    background: '#f0faf6',
    display: 'flex',
    flexDirection: 'column',
    borderRight: '1px solid #b6ddd0'
  },
  sidebarHeader: {
    px: 2.5,
    pt: 2.5,
    pb: 2,
    borderBottom: '1px solid #cceee3'
  },
  navBtn: isActive => ({
    width: '100%',
    textAlign: 'left',
    px: 1.5,
    py: 1.2,
    mb: 0.5,
    borderRadius: '10px',
    cursor: 'pointer',
    transition: 'all 0.15s ease',
    background: isActive ? '#1d9e75' : 'transparent',
    border: isActive ? '1px solid #178a64' : '1px solid transparent',
    boxShadow: isActive ? '0 2px 10px rgba(29,158,117,0.28)' : 'none',
    '&:hover': {
      background: isActive ? '#1d9e75' : '#e1f4ee'
    }
  }),
  contentHeader: {
    px: 3,
    py: 1.8,
    borderBottom: '1px solid #cceee3',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexShrink: 0,
    background: '#fff',
    gap: 2,
    flexWrap: 'wrap'
  },
  sectionCard: {
    background: '#fff',
    borderRadius: '12px',
    border: '1px solid #e2e8f0',
    p: 2.5,
    mb: 2.5,
    boxShadow: '0 1px 2px rgba(0,0,0,0.03)'
  }
};

function Carriers(props) {
  const [proNumberSuffixPosition, setProNumbersuffixPosition] = useState('Pre');
  const [surchargeType, setSurchargeType] = useState('%');
  const [paymentTerms, setPaymentTerms] = useState('Inbound');
  const [LTLServiceType, setLTLServiceType] = useState('All');
  const [parcelServiceType, setParcelServiceType] = useState('All');
  const [secondParcelServiceType, setSecondParcelServiceType] = useState('All');
  const [secondLTLServiceType, setSecondLTLServiceType] = useState('All');
  const [ratesType, setRatesType] = useState('All');
  const [guaranteedType, setGuaranteedType] = useState('All');
  const [secondPaymentTerms, setSecondPaymentTerms] = useState('Inbound');
  const [secondRatesType, setSecondRatesType] = useState('All');
  const [secondGuaranteedType, setSecondGuaranteedType] = useState('All');
  const [surchargeValue, setSurchargeValue] = useState('');
  const [thresholdValue, setThresholdValue] = useState('');
  const [thresholdType, setThresholdType] = useState('$');
  const [proNumberSuffixValue, setProNumberSuffixValue] = useState('');
  const [proNumberFrom, setProNumberFrom] = useState('');
  const [proNumberTo, setProNumberTo] = useState('');
  const [proNumberAlert, setProNumberAlert] = useState('');
  const [proNumberLeft, setProNumberLeft] = useState('');
  const [proNumberTotals, setProNumberTotals] = useState('');
  const [pronmbsApiData, setPronmbsApiData] = useState(null);
  const surchargeTypeArr = ['All', 'Inbound', 'Outbound', 'Third Party'];
  const [selectedOptions, setSelectedOptions] = useState([]);

  // ── NEW: sidebar active section state (no sub-tabs needed) ──
  const [sidebarSection, setSidebarSection] = useState('operations');

  const handleChangeProNmb = event => {
    setProNumbersuffixPosition(event.target.value);
  };

  const UserIsAdmin = useSelector(state => state.userDetails.isAdmin);
  const userRolePermissions = useSelector(
    state => state.userDetails.userRolePermissionsArr
  );
  const AgencyID = useSelector(state => state.userDetails.agencyLoginID);
  const [showEditMode, setShowEditMode] = useState(false);
  const history = useHistory();
  const [carriersLoader, setCarriersLoader] = useState(true);
  const [carriers, setCarriers] = useState([]);
  const [carrierProSeriesStatus, setCarrierProSeriesStatus] = useState([]);
  const [TLcarriers, setTLCarriers] = useState([]);
  const [LTLCarriers, setLTLCarriers] = useState([]);
  const [parcelCarriers, setParcelCarriers] = useState([]);
  const [configuredCarrierName, setConfiguredCarrierName] = useState('');
  const [configuredCarrierID, setConfiguredCarrierID] = useState(0);

  const [configuredCarrierArray, setConfiguredCarrierArray] = useState([]);
  const [validattionErrors, setValidattionErrors] = useState({});

  const [carrierID, setCarrierID] = useState('');
  const [thirdPatyAccDetails, setThirdPatyAccDetails] = useState({
    id: 0,
    status: true,
    thirdPartyAccountNumber: '',
    companyName: '',
    streetLines: '',
    city: '',
    state: '',
    postalCode: '',
    countryCode: '',
    phoneNumber: '',
    emailAddress: ''
  });

  const [phoneNumberValidError, setPhoneNumberValidError] = useState(false);
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [email, setEmail] = useState('');
  const [validationErrors, setValidationErrors] = useState({});
  const [isEProSeriesGenerate, setIsEProSeriesGenerate] = useState(null);
  const [carrierStatus, setCarrierStatus] = useState('');
  const [userPermissionsArr, setUserPermissionsArr] =
    useState(userRolePermissions);
  const [createUpdateCarrier, setCreateUpdateCarrier] = useState(false);
  const [carrierTabValue, setCarrierTabValue] = useState('1');

  const mncolumns = [
    {
      accessorKey: 'logo',
      id: 'logo',
      header: 'Logo',
      size: 1,
      Cell: ({ cell, row }) => (
        <>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              minWidth: '100px',
              maxWidth: '100px',
              paddingLeft: '25px'
            }}
          >
            <AvatarGroup spacing='small'>
              <Avatar
                variant='circular'
                alt={cell.getValue()}
                src={base_logo_url + cell.getValue()}
                sx={{
                  width: { xs: 35, sm: 40 },
                  height: { xs: 35, sm: 40 },
                  mx: { xs: 3 },
                  background:
                    row.original.cType === 'TL'
                      ? ''
                      : 'linear-gradient(135deg, #6D5DFB, #46C8FF)',
                  '& img': {
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    borderRadius: '50%',
                    backgroundColor: row.original.cType === 'TL' ? '' : '#fff',
                    padding: 0
                  }
                }}
              />
            </AvatarGroup>
          </Box>
          {userPermissionsArr &&
            (UserIsAdmin ||
              userPermissionsArr?.some(
                permissions =>
                  permissions.permissionName === 'TL Carriers' &&
                  (permissions.level2 || permissions.level4)
              )) &&
            value == '2' && (
              <div
                className={
                  isMobile
                    ? 'table-row-buttons-users-mobile py-0'
                    : 'table-row-buttons-users py-1'
                }
                style={
                  isMobile
                    ? { marginLeft: '-70px', position: 'absolute' }
                    : { left: '8px', position: 'absolute' }
                }
              >
                <button
                  onClick={event => {
                    setCreateUpdateCarrier(true);
                    history.push('/create-carrier', row.original);
                  }}
                  className={
                    isMobile
                      ? 'bg-grey border-0 p-2 fw-bold'
                      : 'bg-white border-0 p-2 fw-bold'
                  }
                  style={{
                    color: '#3361FF',
                    borderRadius: '4px',
                    margin: '0 0 0 40'
                  }}
                >
                  <Tooltip title='View / Update'>
                    <svg
                      className='mx-0'
                      width='17'
                      height='17'
                      viewBox='0 0 13 13'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M1.33333 11.1693H2.26667L8.01667 5.41927L7.08333 4.48594L1.33333 10.2359V11.1693ZM10.8667 4.4526L8.03333 1.6526L8.96667 0.719271C9.22222 0.463715 9.53611 0.335938 9.90833 0.335938C10.2806 0.335938 10.5944 0.463715 10.85 0.719271L11.7833 1.6526C12.0389 1.90816 12.1722 2.21649 12.1833 2.5776C12.1944 2.93872 12.0722 3.24705 11.8167 3.5026L10.8667 4.4526ZM9.9 5.43594L2.83333 12.5026H0V9.66927L7.06667 2.6026L9.9 5.43594Z'
                        fill='#3361FF'
                      />
                    </svg>
                  </Tooltip>
                </button>
              </div>
            )}
          {canShowSettings && row.original.active && (
            <div
              className={
                isMobile
                  ? 'table-row-buttons-users-mobile py-2'
                  : 'table-row-buttons-users py-2'
              }
              style={
                isMobile
                  ? { marginLeft: '-30px', position: 'absolute' }
                  : { marginLeft: '-2vw', position: 'absolute' }
              }
            >
              <Tooltip arrow title='Settings'>
                <SettingsIcon
                  style={{ color: '#3361FF' }}
                  sx={{ cursor: 'pointer', marginRight: 2 }}
                  onClick={e => handleUpdateCarrier(e, row.original)}
                />
              </Tooltip>
            </div>
          )}
        </>
      )
    },
    {
      accessorKey: 'name',
      id: 'name',
      header: 'Carrier Name'
    },
    {
      accessorKey: 'contactEmail',
      id: 'contactEmail',
      header: 'Carrier Email'
    },
    {
      accessorKey: 'active',
      id: 'active',
      header: 'Carrier Status',
      Cell: ({ renderedCellValue, row }) => (
        <>
          {
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              {renderedCellValue ? 'Active' : 'In-Active'}
            </Box>
          }
        </>
      )
    },
    {
      accessorKey: 'cSubType',
      id: 'cSubType',
      header: 'SubType'
    },

    {
      accessorKey: 'thirdPartyAccountNumber',
      id: 'thirdPartyAccountNumber',
      header: '3rd Party Account'
    },
    {
      accessorKey: 'proNumberSeries',
      id: 'proNumberSeries',
      header: 'ProNumber Series',
      Cell: ({ row }) => {
        const proNumberStart = row.original.proNumberStart;
        const proNumberEnd = row.original.proNumberEnd;
        const hasSeries = proNumberStart && proNumberEnd;

        return (
          <Box
            sx={{
              width: hasSeries ? '100%' : '80%',
              textAlign: hasSeries ? 'left' : 'center'
            }}
          >
            {hasSeries ? `${proNumberStart} - ${proNumberEnd}` : '-'}
          </Box>
        );
      }
    },
    {
      accessorKey: 'proNumberTotals',
      id: 'proNumberTotals',
      header: 'Total ProNumbers',
      size: 50
    },
    {
      accessorKey: 'proNumberConsumed',
      id: 'proNumberConsumed',
      header: 'Consumed ProNumbers',
      size: 50,
      Cell: ({ row }) => {
        return (
          <Box
            sx={{
              width: '100%',
              textAlign: 'left'
            }}
          >
            {row.original.proNumberTotals &&
              row.original.proNumberLeft &&
              calculateConsumed(
                row.original.proNumberTotals,
                row.original.proNumberLeft
              )}
          </Box>
        );
      }
    },
    {
      accessorKey: 'proNumberLeft',
      id: 'proNumberLeft',
      header: <div style={{ whiteSpace: 'nowrap' }}>Remaining ProNumbers</div>
    }
  ];

  const [value, setValue] = useState(1);
  const [columnsData, setColumnsData] = useState(mncolumns);

  useEffect(() => {
    if (!configuredCarrierName) return;
    setCarrierTabValue(!isEProSeriesGenerate ? '2' : '1');
    // sync sidebar section
    setSidebarSection(!isEProSeriesGenerate ? 'account' : 'operations');
  }, [isEProSeriesGenerate]);

  const isMobile = useIsMobile();

  const [claimSettingsObj, setClaimSettingsObj] = useState({
    carrierId: 0,
    contactName: '',
    contactEmail: '',
    contactPhone: '',
    copyTo: ''
  });

  const [errors, setErrors] = useState({
    contactEmail: '',
    contactPhone: ''
  });

  const [isNewUI, setIsNewUI] = useState(false);
  const [listView, setListView] = useState(true);
  const selectedCarrier = useRef(null);

  const handleToggle = event => {
    handleChange('event', 1);
    setIsNewUI(event.target.checked);
    setDrawerOpen(false);
  };

  const [forceUpdateCounter, setForceUpdateCounter] = useState(0);
  // Drawer state (replaces Dialog)
  const [drawerOpen, setDrawerOpen] = useState(false);

  const forceUpdate = () => {
    setCreateUpdateCarrier(false);
    setForceUpdateCounter(prev => prev + 1);
  };

  const handleClaimSettingsChange = (field, value) => {
    setClaimSettingsObj(prev => ({ ...prev, [field]: value }));

    if (field === 'contactEmail') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      setErrors(prev => ({
        ...prev,
        contactEmail: emailRegex.test(value) ? '' : 'Enter a valid email'
      }));
    }

    if (field === 'contactPhone') {
      const digitsOnly = value.replace(/\D/g, '');
      if (digitsOnly.length !== 10) {
        setErrors(prev => ({
          ...prev,
          contactPhone: 'Phone number must be 10 digits'
        }));
      } else {
        setErrors(prev => ({
          ...prev,
          contactPhone: ''
        }));
      }
    }
  };

  const selectedTab = useRef(1);
  const [activeCarriers, setActiveCarriers] = useState([]);

  useEffect(() => {
    if (UserIsAdmin) {
      const allCarriers = [
        { permissionName: 'LTL Carriers', value: 1 },
        { permissionName: 'TL Carriers', value: 2 },
        { permissionName: 'Parcel Carriers', value: 3 }
      ];

      setUserPermissionsArr(allCarriers);
      setActiveCarriers(allCarriers);
      setColumnsData(mncolumns);
      selectedTab.current = 1;
      return;
    }

    if (userRolePermissions?.length && !UserIsAdmin) {
      const filteredCarrierPermissions = userRolePermissions.filter(item =>
        item.permissionName?.includes('Carriers')
      );

      setUserPermissionsArr(filteredCarrierPermissions);

      if (createUpdateCarrier) {
        setColumnsData(mncolumns);
      }

      const mappedActive = filteredCarrierPermissions
        .filter(c => {
          const hasAnyLevelTrue = Object.keys(c).some(
            key => key.startsWith('level') && c[key] === true
          );
          return c.status === true || hasAnyLevelTrue;
        })
        .map(c => ({
          ...c,
          value:
            c.value ||
            (c.permissionName.includes('LTL Carriers')
              ? 1
              : c.permissionName.includes('TL Carriers')
                ? 2
                : c.permissionName.includes('Parcel Carriers')
                  ? 3
                  : '')
        }));

      setActiveCarriers(mappedActive);

      if (mappedActive.length > 0) {
        const hasLTL = mappedActive.some(c => c.value === 1);
        selectedTab.current = hasLTL ? 1 : mappedActive[0].value;
      }
    }
  }, [UserIsAdmin, userRolePermissions, createUpdateCarrier]);

  const handleSuccessCarriersStateFlow = (ApiRes, type, action) => {
    const CarrierArray = ApiRes?.data?.data;
    setCarriersLoader(false);

    const LTL = CarrierArray.filter(items => items.cType === 'LTL').sort(
      (a, b) =>
        (a.name || '').toLowerCase().localeCompare((b.name || '').toLowerCase())
    );

    const TL = CarrierArray.filter(items => items.cType === 'TL').sort((a, b) =>
      (a.name || '').toLowerCase().localeCompare((b.name || '').toLowerCase())
    );

    const Parcels = CarrierArray.filter(items => items.cType === 'Parcel').sort(
      (a, b) =>
        (a.name || '').toLowerCase().localeCompare((b.name || '').toLowerCase())
    );

    setLTLCarriers(LTL);
    setTLCarriers(TL);
    setParcelCarriers(Parcels);

    if (!isNewUI) {
      if (props?.location?.state === 'Non-LTL' && !action) {
        setCarriers(TL);
        selectedTab.current = 2;
        handleChange('event', 2);
        return;
      }

      const hasPermission = permissionName => {
        const carrierData = userRolePermissions.find(
          item => item.permissionName === permissionName
        );
        if (!carrierData) return false;
        return Object.entries(carrierData).some(
          ([key, value]) =>
            (key.toLowerCase().includes('level') ||
              key.toLowerCase().includes('status')) &&
            value === true
        );
      };

      if (UserIsAdmin && !action) {
        setCarriers(LTL);
        selectedTab.current = 1;
      } else if (type === 'LTL' && hasPermission('LTL Carriers')) {
        setCarriers(LTL);
        selectedTab.current = 1;
      } else if (!UserIsAdmin) {
        const getAvailableCarrierType = () => {
          if (hasPermission('LTL Carriers')) return { carriers: LTL, tab: 1 };
          if (hasPermission('TL Carriers')) return { carriers: TL, tab: 2 };
          if (hasPermission('Parcel Carriers'))
            return { carriers: Parcels, tab: 3 };
          return { carriers: [], tab: null };
        };

        switch (selectedTab.current) {
          case '1':
            if (hasPermission('LTL Carriers')) {
              setCarriers(LTL);
            } else {
              const available = getAvailableCarrierType();
              setCarriers(available.carriers);
              if (available.tab) selectedTab.current = available.tab;
            }
            break;

          case '2':
            if (hasPermission('TL Carriers')) {
              setCarriers(TL);
            } else {
              const available = getAvailableCarrierType();
              setCarriers(available.carriers);
              if (available.tab) selectedTab.current = available.tab;
            }
            break;

          case '3':
            if (hasPermission('Parcel Carriers')) {
              setCarriers(Parcels);
            } else {
              const available = getAvailableCarrierType();
              setCarriers(available.carriers);
              if (available.tab) selectedTab.current = available.tab;
            }
            break;

          default:
            const available = getAvailableCarrierType();
            setCarriers(available.carriers);
            if (available.tab) selectedTab.current = available.tab;
        }
      }
    }
  };

  const fetchCarriers = () => {
    GetCarriers(AgencyID)
      .then(res => res.status === 200 && handleSuccessCarriersStateFlow(res))
      .catch(err => console.log(err, 'err'));
  };

  useEffect(() => {
    fetchCarriers();

    GetCarrierProSeriesStatus(AgencyID)
      .then(res => {
        setCarrierProSeriesStatus(res?.data?.data);
      })
      .catch(err => console.log(err, 'err'));
  }, []);

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openConfirmDialogImport, setOpenConfirmDialogImport] = useState(false);
  const [openEProDialog, setOpenEProDialog] = useState(false);
  const [openEProDialogGenerate, setOpenEProDialogGenerate] = useState(false);
  const [proNumberErrors, setProNumbersErrors] = useState({});
  const [proNmbChanged, setProNmbChanged] = useState(false);

  const [eproSeriesData, setEproSeriesData] = useState([]);
  const [eproSeriesDataGenerate, setEproSeriesDataGenerate] = useState([]);
  const [eProSeriesGenerateError, setEProSeriesGenerateError] = useState('');

  const [loadingEproSeries, setLoadingEproSeries] = useState(false);
  const [loadingEproSeriesGenerate, setLoadingEproSeriesGenerate] =
    useState(false);

  const handleGenerateEProSeriesDialog = () => {
    if (configuredCarrierID === 10 && !proNumberSuffixValue) {
      setProNumbersErrors({
        ...proNumberErrors,
        proNumberSuffixValue: 'Please enter suffix value'
      });
      return;
    }
    if (!proNumberFrom) {
      setProNumbersErrors({
        ...proNumberErrors,
        proNumberFrom: 'Please enter starting pro-number'
      });
      return;
    }
    if (!proNumberTo) {
      setProNumbersErrors({
        ...proNumberErrors,
        proNumberTo: 'Please enter ending pro-number'
      });
      return;
    }
    if (
      [18, 5, 255, 16, 4, 19].includes(configuredCarrierID) &&
      proNumberFrom.toString().length !== 8
    ) {
      setProNumbersErrors({
        ...proNumberErrors,
        proNumberFrom: 'Starting pro-number must be equal to 8 digits'
      });
      return;
    }
    if (
      [18, 5, 255, 16, 4, 19].includes(configuredCarrierID) &&
      proNumberTo.toString().length !== 8
    ) {
      setProNumbersErrors({
        ...proNumberErrors,
        proNumberTo: 'Ending pro-number must be equal to 8 digits'
      });
      return;
    }
    if (
      [17].includes(configuredCarrierID) &&
      proNumberFrom.toString().length !== 10
    ) {
      setProNumbersErrors({
        ...proNumberErrors,
        proNumberFrom: 'Starting pro-number must be equal to 10 digits'
      });
      return;
    }
    if (
      [17].includes(configuredCarrierID) &&
      proNumberTo.toString().length !== 10
    ) {
      setProNumbersErrors({
        ...proNumberErrors,
        proNumberTo: 'Ending pro-number must be equal to 10 digits'
      });
      return;
    }
    if (
      [2].includes(configuredCarrierID) &&
      proNumberFrom.toString().length !== 9
    ) {
      setProNumbersErrors({
        ...proNumberErrors,
        proNumberFrom: 'Starting pro-number must be equal to 9 digits'
      });
      return;
    }
    if (
      [2].includes(configuredCarrierID) &&
      proNumberTo.toString().length !== 9
    ) {
      setProNumbersErrors({
        ...proNumberErrors,
        proNumberTo: 'Ending pro-number must be equal to 9 digits'
      });
      return;
    }
    if (
      [10].includes(configuredCarrierID) &&
      proNumberFrom.toString().length !== 7
    ) {
      setProNumbersErrors({
        ...proNumberErrors,
        proNumberFrom: 'Starting pro-number must be equal to 7 digits'
      });
      return;
    }
    if (
      [10].includes(configuredCarrierID) &&
      proNumberTo.toString().length !== 7
    ) {
      setProNumbersErrors({
        ...proNumberErrors,
        proNumberTo: 'Ending pro-number must be equal to 7 digits'
      });
      return;
    }
    if (parseInt(proNumberFrom) > 2147483647) {
      setProNumbersErrors({
        ...proNumberErrors,
        proNumberFrom:
          'Starting pro-number exceeds the limit of maximum number: 2147483647'
      });
      return;
    }
    if (parseInt(proNumberTo) > 2147483647) {
      setProNumbersErrors({
        ...proNumberErrors,
        proNumberTo:
          'Ending pro-number exceeds the limit of maximum number: 2147483647'
      });
      return;
    }
    if (
      proNumberFrom &&
      proNumberTo &&
      parseInt(proNumberTo) < parseInt(proNumberFrom)
    ) {
      setProNumbersErrors({
        ...proNumberErrors,
        proNumberTo:
          'Ending pro-number cannot be smaller than starting pro-number'
      });
      return;
    }

    setLoadingEproSeriesGenerate(true);
    setOpenEProDialogGenerate(true);

    const dataObj = {
      carrierId: configuredCarrierID,
      suffix: proNumberSuffixValue,
      startFrom: proNumberFrom,
      endTo: proNumberTo
    };
    GenerateCarrierEProSeries(dataObj)
      .then(res => {
        setEproSeriesDataGenerate(res?.data?.data);
        setLoadingEproSeriesGenerate(false);
      })
      .catch(err => {
        setEProSeriesGenerateError(err?.response?.data);
        setLoadingEproSeriesGenerate(false);
      });
  };

  const handleImportEProSeries = () => {
    const dataObj = eproSeriesDataGenerate.map(epronumber => ({
      carrierId: configuredCarrierID,
      locationId: 0,
      serialNumber: epronumber.serialNumber,
      draftProNumber: epronumber.draftProNumber,
      checkDigit: epronumber.checkDigit,
      finalProNumber: epronumber.finalProNumber,
      suffix: String(proNumberSuffixValue || ''),
      startFrom: String(proNumberFrom || ''),
      endTo: String(proNumberTo || '')
    }));

    ImportCarrierEProSeries(dataObj)
      .then(res => {
        handleCloseEProSeriesDialogGenerate();
        handleConfirmDialogCloseImport();
        if (isNewUI) {
          fetchCarriers();
        }
        successToast('E-PRO series imported successfully');
      })
      .catch(err => {
        handleCloseEProSeriesDialogGenerate();
        handleConfirmDialogCloseImport();
        ErrorToast('E-PRO series import failed');
      });
  };

  const handleImportEProSeriesDialog = () => {
    setOpenConfirmDialogImport(true);
  };

  const handleOpenEProSeriesDialog = () => {
    setLoadingEproSeries(true);
    setOpenEProDialog(true);
    GetCarrierEProSeries(configuredCarrierID)
      .then(res => {
        setEproSeriesData(res?.data?.data);
        setLoadingEproSeries(false);
      })
      .catch(err => {
        setLoadingEproSeries(false);
      });
  };

  const handleCloseEProSeriesDialog = () => {
    setEproSeriesData([]);
    setOpenEProDialog(false);
  };

  const handleCloseEProSeriesDialogGenerate = () => {
    setEproSeriesDataGenerate([]);
    setEProSeriesGenerateError('');
    setOpenEProDialogGenerate(false);
  };

  const eproSeriesColumns = [
    {
      accessorKey: 'draftNumber',
      id: 'draft',
      header: 'PRO #',
      size: 50,
      Cell: ({ renderedCellValue }) =>
        renderedCellValue ? (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <span>{renderedCellValue}</span>
          </Box>
        ) : null
    },
    {
      accessorKey: 'checkDigit',
      id: 'checkDigit',
      header: 'Check Digit',
      size: 50,
      Cell: ({ renderedCellValue }) => (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <span>{renderedCellValue}</span>
        </Box>
      )
    },
    {
      accessorKey: 'finalNumber',
      id: 'final',
      header: 'Final PRO #',
      size: 50,
      Cell: ({ renderedCellValue }) =>
        renderedCellValue ? (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <span>{renderedCellValue}</span>
          </Box>
        ) : null
    },
    {
      accessorKey: 'bolNumber',
      id: 'bol',
      header: 'BOL #',
      size: 50,
      Cell: ({ renderedCellValue }) =>
        renderedCellValue ? (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <span>{renderedCellValue}</span>
          </Box>
        ) : null
    },
    {
      accessorKey: 'status',
      id: 'status',
      header: 'Status',
      size: 50,
      Cell: ({ renderedCellValue, row }) =>
        renderedCellValue ? (
          <Chip
            sx={
              row.original.status.toLowerCase() === 'booked'
                ? { color: '#1b5e20', backgroundColor: '#c8e6c9' }
                : { color: '#448aff', backgroundColor: '#bbdefb' }
            }
            label={renderedCellValue}
          />
        ) : null
    }
  ];

  const eproSeriesColumnsGenerate = [
    {
      accessorKey: 'serialNumber',
      id: 'serialno',
      header: 'Sr #',
      size: 50,
      Cell: ({ renderedCellValue }) =>
        renderedCellValue ? (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <span>{renderedCellValue}</span>
          </Box>
        ) : null
    },
    {
      accessorKey: 'draftProNumber',
      id: 'draftprono',
      header: 'PRO #',
      size: 50,
      Cell: ({ renderedCellValue }) =>
        renderedCellValue ? (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <span>{renderedCellValue}</span>
          </Box>
        ) : null
    },
    {
      accessorKey: 'checkDigit',
      id: 'checkDigit',
      header: 'Check Digit',
      size: 50,
      Cell: ({ renderedCellValue }) => (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <span>{renderedCellValue}</span>
        </Box>
      )
    },
    {
      accessorKey: 'finalProNumber',
      id: 'final',
      header: 'Final PRO #',
      size: 50,
      Cell: ({ renderedCellValue }) =>
        renderedCellValue ? (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <span>{renderedCellValue}</span>
          </Box>
        ) : null
    }
  ];

  const handleConfirmationCarrierSettins = () => {
    let proNumberErrors = {};
    if (
      proNumberFrom &&
      proNumberTo &&
      parseInt(proNumberTo) < parseInt(proNumberFrom)
    ) {
      setProNumbersErrors({
        ...proNumberErrors,
        proNumberTo: 'ending pro-number cannot be less than starting pronumber'
      });
    } else if (proNumberFrom && proNumberTo && !proNumberAlert) {
      proNumberErrors['proNumberAlert'] = 'Enter minimum pro-number for Alert';
      setProNumbersErrors(proNumberErrors);
    } else setOpenConfirmDialog(true);
  };

  const handleConfirmDialogClose = () => {
    setOpenConfirmDialog(false);
  };
  const handleConfirmDialogCloseImport = () => {
    setOpenConfirmDialogImport(false);
  };

  const handleCloseDrawer = () => {
    selectedCarrier.current = {};
    setCreateUpdateCarrier(false);
    setValidationErrors({ ...validationErrors, emailError: null });
    setErrors({});
    setClaimSettingsObj({
      carrierId: 0,
      contactEmail: '',
      contactName: '',
      contactPhone: '',
      copyTo: ''
    });
    setEmail('');
    setConfiguredCarrierArray([]);
    setDrawerOpen(false);
    setValidattionErrors({});
    setCarrierID('');
    setCarrierStatus('');
    setProNumbersuffixPosition('Prefix');
    setProNumberSuffixValue('');
    setProNumberFrom('');
    setProNumberTo('');
    setProNumberAlert('');
    setProNumberLeft('');
    setProNumberTotals('');
    setSurchargeType('%');
    setSurchargeValue('');
    setSelectedOptions([]);
    setThirdPatyAccDetails({
      id: 0,
      status: true,
      thirdPartyAccountNumber: '',
      companyName: '',
      streetLines: '',
      city: '',
      state: '',
      postalCode: '',
      countryCode: '',
      phoneNumber: '',
      emailAddress: ''
    });
    setConfiguredCarrierName('');
    setConfiguredCarrierID(0);
    setProNumbersErrors({});
    setThresholdType('$');
    setThresholdValue('');
    // reset sidebar state
    setSidebarSection('operations');
  };

  const handleUpdateCarrier = (e, items) => {
    if (!isNewUI) {
      e.stopPropagation();
    }
    setListView(false);
    setPronmbsApiData(items);
    setDrawerOpen(true);
    setSurchargeType(items.surchargeType ? items.surchargeType : '%');
    setSelectedOptions(
      items.surchargeApplyOn ? items.surchargeApplyOn.split(',') : []
    );
    setIsEProSeriesGenerate(items.isEProSeriesGenerate);
    setSurchargeValue(items.surcharge ? items.surcharge : '');
    setCarrierID(items.id);
    setCarrierStatus(items.active);
    items.proNumberSuffixPosition &&
      setProNumbersuffixPosition(items.proNumberSuffixPosition);
    items.proNumberSuffix && setProNumberSuffixValue(items.proNumberSuffix);
    items.proNumberStart && setProNumberFrom(items.proNumberStart);
    items.proNumberEnd && setProNumberTo(items.proNumberEnd);
    items.proNumberAlertOn && setProNumberAlert(items.proNumberAlertOn);
    items.proNumberLeft
      ? setProNumberLeft(items.proNumberLeft)
      : setProNumberLeft(0);
    items.proNumberTotals && setProNumberTotals(items.proNumberTotals);
    items.proNumberAlertNotifyTo && setEmail(items.proNumberAlertNotifyTo);
    setThirdPatyAccDetails({
      ...thirdPatyAccDetails,
      id: items.id ? items.id : 0,
      thirdPartyAccountNumber: items.thirdPartyAccountNumber
        ? items.thirdPartyAccountNumber
        : '',
      companyName: items.tpCompanyName ? items.tpCompanyName : '',
      streetLines: items.tpStreetLines ? items.tpStreetLines : '',
      city: items.tpCity ? items.tpCity : '',
      state: items.tpStateOrProvinceCode ? items.tpStateOrProvinceCode : '',
      postalCode: items.tpPostalCode ? items.tpPostalCode : '',
      countryCode: items.tpCountryCode ? items.tpCountryCode : '',
      phoneNumber: items.tpPhoneNumber ? items.tpPhoneNumber : '',
      emailAddress: items.tpEmail ? items.tpEmail : ''
    });
    items.name && setConfiguredCarrierName(items.name);
    setConfiguredCarrierID(items.carrierId);
    setClaimSettingsObj({
      carrierId: items.carrierId,
      contactEmail: items.claimContactEmail,
      contactName: items.claimContactPerson,
      contactPhone: items.claimContactPhone,
      copyTo: items.claimContactCC
    });
    setPaymentTerms(
      items.rqSettingType === 'Both' && items.rqSettingType2 === 'Both'
        ? 'Inbound'
        : items.rqSettingType
    );
    setRatesType(items.rqSettingTypeInfo);
    setGuaranteedType(items.rqSettingTypeFilter);
    setSecondPaymentTerms(items.rqSettingType2);
    setSecondRatesType(items.rqSettingTypeInfo2);
    setSecondGuaranteedType(items.rqSettingTypeFilter2);
    setThresholdValue(items.iaThreshold ? items.iaThreshold : '');
    setThresholdType(items.iaThresholdType ? items.iaThresholdType : '$');
    // reset sidebar to default
    setSidebarSection('operations');
  };

  const handleSuccessGetCarriers = action => {
    GetCarriers(AgencyID)
      .then(
        res =>
          res.status === 200 &&
          handleSuccessCarriersStateFlow(res, 'LTL', action)
      )
      .catch(err => console.log(err, 'err'));
  };

  const handleUpdateCarrierRequest = () => {
    let obj = {
      id: carrierID,
      proNumberSuffix: proNumberSuffixValue,
      proNumberSuffixPosition: proNumberSuffixPosition,
      proNumberStart: proNumberFrom ? proNumberFrom : 0,
      proNumberEnd: proNumberTo ? proNumberTo : 0,
      proNumberLeft:
        !proNmbChanged && proNumberLeft !== null
          ? proNumberLeft
          : handleRemainingPro(),
      proNumberAlertOn: proNumberAlert ? proNumberAlert : 0,
      proNumberAlertNotifyTo: email ? email : ''
    };
    UpdateCarrierProSeries(obj)
      .then(res => {
        successToast('Carrier Settings Updated!');
        setDrawerOpen(false);
        setOpenConfirmDialog(false);
        handleSuccessGetCarriers('Updated');
      })
      .catch(err => {
        ErrorToast(err?.message);
        handleConfirmDialogClose();
        console.log(err, 'err');
      });
  };

  const calculateConsumed = (totals, left) => {
    const totalsNum = totals ? Number(totals) : 0;
    const leftNum = left ? Number(left) : 0;
    if (isNaN(totalsNum) || isNaN(leftNum)) return 0;
    return totalsNum - leftNum;
  };

  useEffect(() => {
    if (!isNewUI && props?.location?.state === 'Non-LTL') {
      setValue(2);
      selectedTab.current = 2;
      handleChange('event', 2);
    }
  }, []);

  const canShowSettings = useMemo(() => {
    if (UserIsAdmin && (value == '1' || value == '3')) return true;
    return userPermissionsArr.some(
      p =>
        ((value == '1' && p.permissionName.includes('LTL Carriers')) ||
          (value == '3' && p.permissionName.includes('Parcel Carriers'))) &&
        p.level2
    );
  }, [userPermissionsArr, value, UserIsAdmin]);

  useEffect(() => {
    if (selectedTab.current == 1 || selectedTab.current == 3) {
      const filteredCol = mncolumns.filter(
        col =>
          col.accessorKey !== 'contactEmail' &&
          col.accessorKey !== 'cSubType' &&
          col.accessorKey !== 'active'
      );
      setColumnsData(filteredCol);
    }
    if (selectedTab.current == 2) {
      const filteredCol = mncolumns.filter(
        col =>
          col.accessorKey !== 'thirdPartyAccountNumber' &&
          col.accessorKey !== 'proNumberSeries' &&
          col.accessorKey !== 'proNumberConsumed' &&
          col.accessorKey !== 'proNumberLeft' &&
          col.accessorKey !== 'proNumberTotals'
      );
      setColumnsData(filteredCol);
    }
  }, [
    selectedTab,
    value,
    carriers,
    LTLCarriers,
    TLcarriers,
    parcelCarriers,
    isNewUI
  ]);

  const handleSurchargeChange = (event, newValue) => {
    if (newValue.includes('All')) {
      setSelectedOptions(surchargeTypeArr.filter(items => items !== 'All'));
    } else {
      setSelectedOptions(newValue.filter(option => option !== 'All'));
    }
  };

  const handleChange = (event, newValue) => {
    selectedTab.current = newValue;
    setValue(newValue);
    if (newValue === 1) {
      setColumnsData(mncolumns);
      setCarriers(LTLCarriers);
    }
    if (newValue === 2) {
      const filteredCol = mncolumns.filter(
        col =>
          col.accessorKey !== 'thirdPartyAccountNumber' &&
          col.accessorKey !== 'proNumberSeries' &&
          col.accessorKey !== 'proNumberConsumed' &&
          col.accessorKey !== 'proNumberLeft' &&
          col.accessorKey !== 'proNumberTotals' &&
          col.accessorKey !== 'cSubType'
      );
      setColumnsData(filteredCol);
      setCarriers(TLcarriers);
    }
    if (newValue === 3) {
      setColumnsData(mncolumns);
      setCarriers(parcelCarriers);
    }
  };

  const handleProNumberFromChange = e => {
    const inputValue = e.target.value;
    const isValidInput = /^[0-9]\d*$/.test(inputValue);
    if (isValidInput) {
      setProNmbChanged(true);
      setProNumbersErrors({ ...proNumberErrors, proNumberFrom: null });
      setProNumberFrom(inputValue);
    } else {
      setProNmbChanged(false);
      setProNumberFrom('');
    }
  };

  const handleProNumberToChange = e => {
    const inputValue = e.target.value;
    const isValidInput = /^[0-9]\d*$/.test(inputValue);
    if (isValidInput) {
      setProNmbChanged(true);
      setProNumbersErrors({ ...proNumberErrors, proNumberTo: null });
      setProNumberTo(inputValue);
    } else {
      setProNmbChanged(false);
      setProNumberTo('');
    }
  };

  const handleProNumberAlertChange = e => {
    const inputValue = e.target.value;
    const isValidInput = /^[0-9]\d*$/.test(inputValue);
    if (isValidInput) {
      setProNumbersErrors({ ...proNumberErrors, proNumberAlert: null });
      setProNumberAlert(inputValue);
    } else {
      setProNumberAlert('');
    }
  };

  const handleCarrierTabChange = (event, newValue) => {
    setCarrierTabValue(newValue);
  };

  const handleSurchargeRequest = () => {
    const surchargeObj = {
      id: carrierID,
      surcharge: surchargeValue ? Number(surchargeValue) : 0,
      surchargeType: surchargeType ? surchargeType : '',
      surchargeApplyOn: selectedOptions.join(',')
    };
    UpdateCarrierSurcharge(surchargeObj)
      .then(res => {
        res.status === 200 && successToast('Surcharge Value Updated!');
        handleSuccessGetCarriers('Updated');
        setDrawerOpen(false);
      })
      .catch(err => ErrorToast(err?.message));
  };

  const handleClaimSettingsRequest = () => {
    const claimObj = {
      carrierId: claimSettingsObj.carrierId ? claimSettingsObj.carrierId : 0,
      contactName: claimSettingsObj.contactName
        ? claimSettingsObj.contactName
        : '',
      contactEmail: claimSettingsObj.contactEmail
        ? claimSettingsObj.contactEmail
        : '',
      contactPhone: claimSettingsObj.contactPhone
        ? claimSettingsObj.contactPhone
        : '',
      copyTo: claimSettingsObj.copyTo ? claimSettingsObj.copyTo : ''
    };
    if (claimSettingsObj.contactName === '') {
      setErrors(prev => ({ ...prev, contactName: 'Contact name is required' }));
    }
    if (
      claimSettingsObj.contactName &&
      claimSettingsObj.contactEmail &&
      claimSettingsObj.contactPhone
    ) {
      UpdateCarrierClaimSettings(claimObj)
        .then(res => {
          res.status === 200 && successToast('Claim Settings Updated!');
          handleSuccessGetCarriers('Updated');
          setDrawerOpen(false);
        })
        .catch(err => ErrorToast(err?.message));
    }
  };

  const handleInvoiceThreshold = () => {
    const thrsholdApiObj = {
      id: carrierID,
      type: thresholdType,
      threshold: thresholdValue ? thresholdValue : 0
    };
    UpdateCarrierInvoiceAuditThreshold(thrsholdApiObj)
      .then(res => {
        res.status === 200 && handleSuccessGetCarriers();
        successToast('Threshold applied successfully!');
        if (!isNewUI) {
          handleCloseDrawer();
        }
      })
      .catch(err => {
        ErrorToast(err?.message);
        console.log(err, 'err ------>>>>');
      });
  };

  const ValidatePhoneNumber = phNumber => {
    const inputValue = phNumber;
    const formattedValue = inputValue
      .replace(/\D/g, '')
      .replace(/^(\d{3})(\d{3})(\d{4})$/, '($1) $2-$3');
    setThirdPatyAccDetails(oldObj => ({
      ...oldObj,
      phoneNumber: formattedValue
    }));
    const errors = {};
    const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
    const isValidPhoneNumber = phoneRegex.test(formattedValue);
    if (isValidPhoneNumber || inputValue === '') {
      setPhoneNumberValidError(false);
      setValidationErrors({ ...validationErrors, phoneNumberErrorBT: null });
    } else {
      setPhoneNumberValidError(true);
      errors['phoneNumberErrorBT'] = 'Enter Valid Phone Number (XXX) XXX-XXXX';
      setValidationErrors(errors);
    }
  };

  const ValidateEmailAddress = emValue => {
    const emailRegex =
      /^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(,[\s]*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})*$/;
    const errors = {};
    setThirdPatyAccDetails(oldObj => ({ ...oldObj, emailAddress: emValue }));
    if (emailRegex.test(emValue) || emValue === '') {
      setIsValidEmail(true);
      setValidationErrors({ ...validationErrors, emailErrorBT: null });
    } else {
      setIsValidEmail(false);
      errors['emailErrorBT'] = 'Enter Valid Email';
    }
    setValidationErrors(errors);
  };

  const handleThirdPartyRequest = () => {
    ValidateEmailAddress(thirdPatyAccDetails.emailAddress);
    if (isValidEmail) {
      ValidatePhoneNumber(thirdPatyAccDetails.phoneNumber);
      if (!phoneNumberValidError) {
        UpdateCarrierThirdPartyInfo(thirdPatyAccDetails)
          .then(res => {
            GetCarriers(AgencyID)
              .then(
                res =>
                  res.status === 200 &&
                  handleSuccessCarriersStateFlow(res, 'LTL', 'Updated')
              )
              .catch(err => console.log(err, 'err'));
            res.status === 200 &&
              successToast('3rd party account updated successfully!');
            if (!isNewUI) {
              handleCloseDrawer();
            }
            setDrawerOpen(false);
          })
          .catch(err => {
            ErrorToast(err?.message);
            setDrawerOpen(false);
          });
      }
    }
  };

  const handleRemainingPro = () => {
    if (proNumberTo - proNumberFrom > 0) return proNumberTo - proNumberFrom + 1;
    else return 0;
  };

  const handleEmailValidation = email => {
    const emailRegex =
      /^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(,[\s]*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})*$/;
    const errors = {};
    setEmail(email);
    if (emailRegex.test(email) || email === '') {
      setIsValidEmail(true);
      setValidationErrors({ ...validationErrors, emailError: null });
    } else {
      setIsValidEmail(false);
      errors['emailError'] = 'Enter Valid Email';
    }
    setValidationErrors(errors);
  };

  const handleRateQuoteSettingsReq = () => {
    const carrierRateSettingsObj = {
      id: carrierID,
      type: secondPaymentTerms === 'Both' ? secondPaymentTerms : paymentTerms,
      typeDetail: secondPaymentTerms === 'Both' ? secondRatesType : ratesType,
      typeDetailFilter:
        secondPaymentTerms === 'Both'
          ? secondRatesType === 'Guaranteed'
            ? secondGuaranteedType
            : ''
          : ratesType === 'Guaranteed'
            ? guaranteedType
            : '',
      type2:
        paymentTerms === 'Both' || secondPaymentTerms === 'Both'
          ? ''
          : secondPaymentTerms,
      typeDetail2:
        paymentTerms === 'Both' || secondPaymentTerms === 'Both'
          ? ''
          : secondRatesType,
      typeDetailFilter2:
        paymentTerms === 'Both' || secondPaymentTerms === 'Both'
          ? ''
          : secondRatesType === 'Guaranteed'
            ? secondGuaranteedType
            : ''
    };
    UpdateCarrierRateQuoteSettings(carrierRateSettingsObj)
      .then(res => {
        res.status === 200 && successToast('Rate Quote Settings Updated!');
        handleSuccessGetCarriers('Updated');
      })
      .catch(err => ErrorToast(err?.message));
    setDrawerOpen(false);
  };

  const handleBackToList = e => {
    setListView(true);
    setShowEditMode(false);
  };

  const rateQuoteUIhandler = (type, name) => {
    if (type === 'Guaranteed') {
      if (configuredCarrierName === 'FedEx' || configuredCarrierName === 'UPS')
        return name === 'xs' || name === 'sm' ? 12 : 3;
      else return name === 'xs' || name === 'sm' ? 12 : 4;
    } else if (
      configuredCarrierName === 'FedEx' ||
      configuredCarrierName === 'UPS'
    )
      return name === 'xs' || name === 'sm' ? 12 : 4;
    else return name === 'xs' || name === 'sm' ? 12 : 6;
  };

  const checkCarrierPermissions = () => {
    if (selectedTab.current == 1) {
      return (
        UserIsAdmin ||
        (userPermissionsArr &&
          (userPermissionsArr.filter(
            permissions =>
              permissions.level3 &&
              permissions.permissionName === 'LTL Carriers'
          ).length ||
            userPermissionsArr.filter(
              permissions =>
                permissions.level4 &&
                permissions.permissionName === 'LTL Carriers'
            ).length))
      );
    } else if (selectedTab.current == 3) {
      return (
        UserIsAdmin ||
        (userPermissionsArr &&
          (userPermissionsArr.filter(
            permissions =>
              permissions.level3 &&
              permissions.permissionName === 'Parcel Carriers'
          ).length ||
            userPermissionsArr.filter(
              permissions =>
                permissions.level4 &&
                permissions.permissionName === 'Parcel Carriers'
            ).length))
      );
    }
    return (
      UserIsAdmin ||
      (userPermissionsArr &&
        (userPermissionsArr.filter(permissions => permissions.level3).length ||
          userPermissionsArr.filter(permissions => permissions.level4).length))
    );
  };

  const handleCreateCarrier = e => {
    e.preventDefault();
    setCreateUpdateCarrier(true);
    selectedTab.current = 2;
    selectedCarrier.current = null;
  };

  const checkCarrierPermissionsLevel4 = () => {
    if (selectedTab.current == 1)
      return (
        UserIsAdmin ||
        (userPermissionsArr &&
          userPermissionsArr.filter(
            permissions =>
              permissions.level4 &&
              permissions.permissionName === 'LTL Carriers'
          ).length)
      );
    else if (selectedTab.current == 3)
      return (
        UserIsAdmin ||
        (userPermissionsArr &&
          userPermissionsArr.filter(
            permissions =>
              permissions.level4 &&
              permissions.permissionName === 'Parcel Carriers'
          ).length)
      );
    return (
      UserIsAdmin ||
      (userPermissionsArr &&
        userPermissionsArr.filter(permissions => permissions.level4).length)
    );
  };

  const handleTabChange = (event, newValue) => {
    selectedTab.current = newValue;
    selectedCarrier.current = {};
    handleCloseDrawer();
    if (newValue == 1) setCarriers(LTLCarriers);
    else if (newValue == 2) setCarriers(TLcarriers);
    else setCarriers(parcelCarriers);
  };

  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('name');
  const [sortOrder, setSortOrder] = useState('asc');

  const filteredCarriers = useMemo(() => {
    let carrierList = carriers;
    if (selectedTab.current) {
      switch (selectedTab.current) {
        case 1:
          carrierList = LTLCarriers;
          break;
        case 2:
          carrierList = TLcarriers;
          break;
        case 3:
          carrierList = parcelCarriers;
          break;
        default:
          carrierList = carriers;
      }
    } else if (selectedCarrier?.current?.cType) {
      switch (selectedCarrier.current.cType) {
        case 'TL':
          carrierList = TLcarriers;
          break;
        case 'LTL':
          carrierList = LTLCarriers;
          break;
        case 'Parcel':
          carrierList = parcelCarriers;
          break;
        default:
          carrierList = carriers;
      }
    }
    let filtered = carrierList.filter(carrier => {
      if (!searchTerm) return true;
      const searchLower = searchTerm.toLowerCase();
      return (
        carrier.name?.toLowerCase().includes(searchLower) ||
        carrier.contactEmail?.toLowerCase().includes(searchLower) ||
        carrier.thirdPartyAccountNumber?.toLowerCase().includes(searchLower) ||
        carrier.surcharge?.toString().includes(searchLower) ||
        carrier.surchargeType?.toLowerCase().includes(searchLower) ||
        carrier.surchargeApplyOn?.toLowerCase().includes(searchLower) ||
        carrier.cSubType?.toLowerCase().includes(searchLower) ||
        carrier.rqSettingTypeInfo?.toLowerCase().includes(searchLower) ||
        carrier.rqSettingType?.toLowerCase().includes(searchLower)
      );
    });
    filtered.sort((a, b) => {
      let aValue, bValue;
      switch (sortBy) {
        case 'name':
          aValue = a.name || '';
          bValue = b.name || '';
          break;
        case 'total':
          aValue = a.proNumberTotals;
          bValue = b.proNumberTotals;
          break;
        case 'consumed':
          aValue = calculateConsumed(a.proNumberTotals, a.proNumberLeft);
          bValue = calculateConsumed(b.proNumberTotals, b.proNumberLeft);
          break;
        case 'remaining':
          aValue = a.proNumberLeft;
          bValue = b.proNumberLeft;
          break;
        case 'surcharge':
          aValue = parseFloat(a.surcharge) || 0;
          bValue = parseFloat(b.surcharge) || 0;
          break;
        default:
          aValue = a.name || '';
          bValue = b.name || '';
      }
      if (sortOrder === 'asc')
        return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
      else return aValue > bValue ? -1 : aValue < bValue ? 1 : 0;
    });
    return filtered;
  }, [
    carriers,
    searchTerm,
    sortBy,
    sortOrder,
    selectedCarrier,
    TLcarriers,
    LTLCarriers,
    parcelCarriers,
    forceUpdateCounter,
    selectedTab.current
  ]);

  const handleSort = field => {
    if (sortBy === field) setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    else {
      setSortBy(field);
      setSortOrder(field === 'name' ? 'asc' : 'desc');
    }
  };

  // ─── Save handler: routes to correct API based on sidebar section ──
  const handleSidebarSave = () => {
    if (sidebarSection === 'operations') {
      // For operations, we need to save ALL sections? Or save individually?
      // Original had separate save per section. We'll keep separate API calls
      // but user expects to save all at once? Let's implement a combined save for Operations
      // For now, save each section independently - but since we removed tabs,
      // we need to decide: Save button saves ALL current changes in the drawer?
      // Simpler: Keep one "Save Changes" button that calls appropriate API based on which section is being edited.
      // But user might edit multiple sections. Let's create a combined save for Operations.
      // I'll implement a function that updates PRO series, surcharge, and threshold in sequence.
      handleSaveAllOperations();
    } else if (sidebarSection === 'account') {
      // Save both 3rd party and claims - could do sequentially
      handleSaveAllAccount();
    } else if (sidebarSection === 'rates') {
      handleRateQuoteSettingsReq();
    }
  };

  // Combined save for Operations (PRO, Surcharge, Threshold)
  const handleSaveAllOperations = async () => {
    // First, validate PRO numbers if they have values
    let hasProChanges = proNumberFrom || proNumberTo || proNumberSuffixValue;
    let hasSurchargeChanges = surchargeValue !== '';
    let hasThresholdChanges = thresholdValue !== '';

    if (hasProChanges) {
      // Validate PRO
      let proErrors = {};
      if (configuredCarrierID === 10 && !proNumberSuffixValue) {
        proErrors['proNumberSuffixValue'] = 'Please enter suffix value';
      }
      if (!proNumberFrom) {
        proErrors['proNumberFrom'] = 'Please enter starting pro-number';
      }
      if (!proNumberTo) {
        proErrors['proNumberTo'] = 'Please enter ending pro-number';
      }
      if (
        [18, 5, 255, 16, 4, 19].includes(configuredCarrierID) &&
        proNumberFrom?.toString().length !== 8
      ) {
        proErrors['proNumberFrom'] =
          'Starting pro-number must be equal to 8 digits';
      }
      if (
        [18, 5, 255, 16, 4, 19].includes(configuredCarrierID) &&
        proNumberTo?.toString().length !== 8
      ) {
        proErrors['proNumberTo'] =
          'Ending pro-number must be equal to 8 digits';
      }
      if (Object.keys(proErrors).length > 0) {
        setProNumbersErrors(proErrors);
        return;
      }
      // Confirmation dialog for PRO changes
      setOpenConfirmDialog(true);
      // After confirmation, handleUpdateCarrierRequest will be called
      return;
    }

    // If no PRO changes, save surcharge and threshold
    if (hasSurchargeChanges) {
      await handleSurchargeRequest();
    }
    if (hasThresholdChanges) {
      await handleInvoiceThreshold();
    }
    setDrawerOpen(false);
  };

  // Combined save for Account (3rd Party + Claims)
  const handleSaveAllAccount = async () => {
    // Save 3rd party first, then claims
    let thirdPartyValid = true;
    ValidateEmailAddress(thirdPatyAccDetails.emailAddress);
    if (!isValidEmail) thirdPartyValid = false;
    ValidatePhoneNumber(thirdPatyAccDetails.phoneNumber);
    if (phoneNumberValidError) thirdPartyValid = false;

    if (thirdPartyValid) {
      await UpdateCarrierThirdPartyInfo(thirdPatyAccDetails)
        .then(async res => {
          successToast('3rd party account updated successfully!');
        })
        .catch(err => {
          ErrorToast(err?.message);
          thirdPartyValid = false;
        });
    }

    // Save claims if contact name is present
    if (claimSettingsObj.contactName) {
      const claimObj = {
        carrierId: claimSettingsObj.carrierId,
        contactName: claimSettingsObj.contactName,
        contactEmail: claimSettingsObj.contactEmail,
        contactPhone: claimSettingsObj.contactPhone,
        copyTo: claimSettingsObj.copyTo
      };
      await UpdateCarrierClaimSettings(claimObj)
        .then(res => {
          successToast('Claim Settings Updated!');
        })
        .catch(err => ErrorToast(err?.message));
    }

    handleSuccessGetCarriers('Updated');
    setDrawerOpen(false);
  };

  // ─── Drawer content (replaces old dialog content) with labeled sections ──
  const DrawerSettingsContent = () => {
    const activeNav = SIDEBAR_NAV.find(n => n.id === sidebarSection);
    return (
      <Box sx={{ display: 'flex', height: '100%', overflow: 'hidden' }}>
        {/* ── LEFT SIDEBAR ── */}
        <Box sx={sidebarStyles.sidebar}>
          {/* Header */}
          <Box sx={sidebarStyles.sidebarHeader}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <Avatar
                src={base_logo_url + (pronmbsApiData?.logo || '')}
                sx={{
                  width: 34,
                  height: 34,
                  background: 'linear-gradient(135deg,#cceee3,#9dddc8)',
                  border: '1px solid #6dc4a8',
                  '& img': {
                    objectFit: 'contain',
                    borderRadius: '50%',
                    backgroundColor: '#fff',
                    padding: 0
                  }
                }}
              />
              <Box>
                <Typography
                  sx={{
                    color: '#0f3d2e',
                    fontSize: 13,
                    fontWeight: 700,
                    lineHeight: 1.2
                  }}
                >
                  {configuredCarrierName}
                </Typography>
                <Typography sx={{ color: '#1d9e75', fontSize: 10.5 }}>
                  Carrier Settings
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* Nav items */}
          <Box sx={{ flex: 1, px: 1.5, py: 2, overflowY: 'auto' }}>
            {SIDEBAR_NAV.map(nav => {
              const isActive = sidebarSection === nav.id;
              return (
                <Box
                  key={nav.id}
                  onClick={() => setSidebarSection(nav.id)}
                  sx={sidebarStyles.navBtn(isActive)}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      mb: 0.5
                    }}
                  >
                    <Box
                      sx={{
                        color: isActive ? '#fff' : '#1d9e75',
                        display: 'flex'
                      }}
                    >
                      {nav.icon}
                    </Box>
                    <Typography
                      sx={{
                        color: isActive ? '#fff' : '#1d9e75',
                        fontSize: 12.5,
                        fontWeight: 600
                      }}
                    >
                      {nav.label}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      gap: 0.5,
                      ml: 2.8
                    }}
                  >
                    {nav.sublabels.map(sl => (
                      <Box
                        key={sl}
                        sx={{
                          px: 1,
                          py: 0.2,
                          borderRadius: '5px',
                          fontSize: 10,
                          fontWeight: 600,
                          background: isActive
                            ? 'rgba(255,255,255,0.22)'
                            : '#e1f4ee',
                          color: isActive ? '#fff' : '#1d9e75'
                        }}
                      >
                        {sl}
                      </Box>
                    ))}
                  </Box>
                </Box>
              );
            })}
          </Box>
        </Box>

        {/* ── RIGHT CONTENT - NO TABS, SECTIONS STACKED VERTICALLY ── */}
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            minWidth: 0,
            background: '#f7fdf9',
            overflow: 'hidden'
          }}
        >
          {/* Content header with description only */}
          <Box sx={sidebarStyles.contentHeader}>
            <Box>
              <Typography
                sx={{ fontSize: 14, fontWeight: 700, color: '#0f3d2e' }}
              >
                {activeNav?.label}
              </Typography>
              <Typography sx={{ fontSize: 11, color: '#1d9e75', mt: 0.2 }}>
                {activeNav?.description}
              </Typography>
            </Box>
          </Box>

          {/* Scrollable form area - sections stacked vertically */}
          <Box sx={{ flex: 1, overflowY: 'auto', px: 3, py: 2.5 }}>
            {/* ── OPERATIONS: All sections visible (PRO, Surcharge, Threshold) ── */}
            {sidebarSection === 'operations' && (
              <>
                {/* PRO Numbers Section */}
                <Box sx={sidebarStyles.sectionCard}>
                  <Typography
                    sx={{
                      fontSize: 13,
                      fontWeight: 700,
                      color: '#0f3d2e',
                      mb: 2,
                      pb: 1,
                      borderBottom: '2px solid #cceee3',
                      display: 'inline-block'
                    }}
                  >
                    PRO Numbers
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                      <FormControl fullWidth size='small'>
                        <FieldLabel label='Suffix Position' />
                        <Select
                          disabled={!checkCarrierPermissions()}
                          fullWidth
                          value={proNumberSuffixPosition}
                          onChange={handleChangeProNmb}
                          sx={inputSx}
                        >
                          <MenuItem value={'Pre'}>Pre</MenuItem>
                          <MenuItem value={'Post'}>Post</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <FieldLabel label={`Enter ${proNumberSuffixPosition}`} />
                      <TextField
                        disabled={!checkCarrierPermissions()}
                        error={Boolean(proNumberErrors['proNumberSuffixValue'])}
                        helperText={proNumberErrors['proNumberSuffixValue']}
                        type='text'
                        fullWidth
                        size='small'
                        value={proNumberSuffixValue}
                        onChange={e => {
                          setProNumberSuffixValue(e.target.value);
                          setProNumbersErrors({
                            ...proNumberErrors,
                            proNumberSuffixValue: null
                          });
                        }}
                        sx={inputSx}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <FieldLabel label='Pro Number From' required />
                      <TextField
                        disabled={!checkCarrierPermissions()}
                        required
                        inputProps={{ min: 0 }}
                        error={Boolean(proNumberErrors['proNumberFrom'])}
                        helperText={proNumberErrors['proNumberFrom']}
                        fullWidth
                        size='small'
                        placeholder='From'
                        value={proNumberFrom}
                        onChange={e => handleProNumberFromChange(e)}
                        sx={inputSx}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <FieldLabel label='Pro Number To' required />
                      <TextField
                        disabled={!checkCarrierPermissions()}
                        inputProps={{ min: proNumberFrom }}
                        required
                        error={Boolean(proNumberErrors['proNumberTo'])}
                        helperText={proNumberErrors['proNumberTo']}
                        fullWidth
                        size='small'
                        placeholder='To'
                        value={proNumberTo}
                        onChange={e => handleProNumberToChange(e)}
                        sx={inputSx}
                      />
                    </Grid>

                    {/* Progress summary */}
                    {proNumberTo && (
                      <Grid item xs={12}>
                        <Box
                          sx={{
                            background: '#fff',
                            border: '1px solid #e2e8f0',
                            borderRadius: '10px',
                            p: 2
                          }}
                        >
                          <Box sx={{ display: 'flex', gap: 1.5, mb: 1.5 }}>
                            {[
                              {
                                label: 'Total',
                                value:
                                  !proNmbChanged && proNumberTotals
                                    ? proNumberTotals
                                    : handleRemainingPro(),
                                color: '#4f46e5',
                                bg: '#eef2ff'
                              },
                              {
                                label: 'Remaining',
                                value:
                                  !proNmbChanged && proNumberLeft !== null
                                    ? proNumberLeft
                                    : handleRemainingPro(),
                                color: '#16a34a',
                                bg: '#f0fdf4'
                              },
                              {
                                label: 'Consumed',
                                value: calculateConsumed(
                                  proNumberTotals || handleRemainingPro(),
                                  proNumberLeft || handleRemainingPro()
                                ),
                                color: '#dc2626',
                                bg: '#fef2f2'
                              }
                            ].map(s => (
                              <Box
                                key={s.label}
                                sx={{
                                  flex: 1,
                                  background: s.bg,
                                  borderRadius: '8px',
                                  p: 1.2,
                                  textAlign: 'center'
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: 10,
                                    color: s.color,
                                    fontWeight: 600,
                                    mb: 0.3
                                  }}
                                >
                                  {s.label}
                                </Typography>
                                <Typography
                                  sx={{
                                    fontSize: 14,
                                    fontWeight: 700,
                                    color: s.color
                                  }}
                                >
                                  {s.value}
                                </Typography>
                              </Box>
                            ))}
                          </Box>
                        </Box>
                      </Grid>
                    )}

                    <Grid item xs={6}>
                      <FieldLabel label='Alert Threshold (min remaining)' />
                      <TextField
                        disabled={!checkCarrierPermissions()}
                        required
                        error={Boolean(proNumberErrors['proNumberAlert'])}
                        helperText={proNumberErrors['proNumberAlert']}
                        inputProps={{ min: 1, max: proNumberTo }}
                        fullWidth
                        size='small'
                        value={proNumberAlert}
                        onChange={e => handleProNumberAlertChange(e)}
                        sx={inputSx}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <FieldLabel label='Alert Email(s)' />
                      <TextField
                        fullWidth
                        disabled={!checkCarrierPermissions()}
                        error={Boolean(validationErrors['emailError'])}
                        helperText={
                          validationErrors.emailError ||
                          (email && 'Comma-separate multiple emails')
                        }
                        onChange={e => handleEmailValidation(e.target.value)}
                        value={email}
                        inputProps={{ style: { fontSize: 13 } }}
                        sx={inputSx}
                        size='small'
                        type='email'
                      />
                    </Grid>
                    <Grid item xs={12} sx={{ display: 'flex', gap: 1.5 }}>
                      <Button
                        size='small'
                        variant='contained'
                        onClick={handleGenerateEProSeriesDialog}
                        disabled={!checkCarrierPermissions()}
                        sx={{ borderRadius: '8px' }}
                      >
                        Generate E-Pro Series
                      </Button>
                      <Button
                        size='small'
                        variant='outlined'
                        onClick={handleOpenEProSeriesDialog}
                        sx={{ borderRadius: '8px' }}
                      >
                        View E-Pro Series
                      </Button>
                    </Grid>
                  </Grid>
                </Box>

                {/* Surcharge Section */}
                <Box sx={sidebarStyles.sectionCard}>
                  <Typography
                    sx={{
                      fontSize: 13,
                      fontWeight: 700,
                      color: '#0f3d2e',
                      mb: 2,
                      pb: 1,
                      borderBottom: '2px solid #cceee3',
                      display: 'inline-block'
                    }}
                  >
                    Surcharge
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={9}>
                      <FieldLabel label='Surcharge Value' />
                      <TextField
                        disabled={!checkCarrierPermissions()}
                        type='number'
                        fullWidth
                        size='small'
                        value={surchargeValue}
                        onChange={e => setSurchargeValue(e.target.value)}
                        sx={inputSx}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <FormControl fullWidth size='small'>
                        <FieldLabel label='Type' />
                        <Select
                          disabled={!checkCarrierPermissions()}
                          fullWidth
                          value={surchargeType}
                          onChange={e => setSurchargeType(e.target.value)}
                          sx={inputSx}
                        >
                          <MenuItem value={'%'}>%</MenuItem>
                          <MenuItem value={'$'}>$</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <FieldLabel label='Apply Surcharge To' />
                      <Autocomplete
                        disabled={!checkCarrierPermissions()}
                        size='small'
                        multiple
                        options={surchargeTypeArr}
                        value={selectedOptions}
                        onChange={handleSurchargeChange}
                        renderInput={params => (
                          <TextField
                            size='small'
                            {...params}
                            variant='outlined'
                            placeholder='Choose...'
                            sx={inputSx}
                          />
                        )}
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => (
                            <Chip
                              key={option}
                              label={option}
                              {...getTagProps({ index })}
                            />
                          ))
                        }
                      />
                    </Grid>
                  </Grid>
                </Box>

                {/* Threshold Section */}
                <Box sx={sidebarStyles.sectionCard}>
                  <Typography
                    sx={{
                      fontSize: 13,
                      fontWeight: 700,
                      color: '#0f3d2e',
                      mb: 2,
                      pb: 1,
                      borderBottom: '2px solid #cceee3',
                      display: 'inline-block'
                    }}
                  >
                    Invoice Audit Threshold
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={9}>
                      <FieldLabel label='Invoice Audit Threshold Value' />
                      <TextField
                        disabled={!checkCarrierPermissions()}
                        type='number'
                        fullWidth
                        size='small'
                        value={thresholdValue}
                        onChange={e => setThresholdValue(e.target.value)}
                        sx={inputSx}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <FormControl fullWidth size='small'>
                        <FieldLabel label='Type' />
                        <Select
                          disabled={!checkCarrierPermissions()}
                          fullWidth
                          value={thresholdType}
                          onChange={e => setThresholdType(e.target.value)}
                          sx={inputSx}
                        >
                          <MenuItem value={'$'}>$</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Box>
              </>
            )}

            {/* ── ACCOUNT: All sections visible (3rd Party + Claims) ── */}
            {sidebarSection === 'account' && (
              <>
                {/* 3rd Party Section */}
                <Box sx={sidebarStyles.sectionCard}>
                  <Typography
                    sx={{
                      fontSize: 13,
                      fontWeight: 700,
                      color: '#0f3d2e',
                      mb: 2,
                      pb: 1,
                      borderBottom: '2px solid #cceee3',
                      display: 'inline-block'
                    }}
                  >
                    3rd Party Account
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <FieldLabel label='Third Party Account Number' />
                      <TextField
                        disabled={!checkCarrierPermissionsLevel4()}
                        value={thirdPatyAccDetails.thirdPartyAccountNumber}
                        fullWidth
                        size='small'
                        onChange={e =>
                          setThirdPatyAccDetails({
                            ...thirdPatyAccDetails,
                            thirdPartyAccountNumber: e.target.value
                          })
                        }
                        sx={inputSx}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FieldLabel label='Company Name' />
                      <TextField
                        disabled={!checkCarrierPermissionsLevel4()}
                        value={thirdPatyAccDetails.companyName}
                        fullWidth
                        size='small'
                        onChange={e =>
                          setThirdPatyAccDetails({
                            ...thirdPatyAccDetails,
                            companyName: e.target.value
                          })
                        }
                        sx={inputSx}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FieldLabel label='Street Address' />
                      <TextField
                        disabled={!checkCarrierPermissionsLevel4()}
                        value={thirdPatyAccDetails.streetLines}
                        fullWidth
                        size='small'
                        onChange={e =>
                          setThirdPatyAccDetails({
                            ...thirdPatyAccDetails,
                            streetLines: e.target.value
                          })
                        }
                        sx={inputSx}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <FieldLabel label='Phone Number' />
                      <TextField
                        disabled={!checkCarrierPermissionsLevel4()}
                        value={thirdPatyAccDetails.phoneNumber}
                        fullWidth
                        size='small'
                        error={Boolean(validationErrors['phoneNumberErrorBT'])}
                        helperText={validationErrors['phoneNumberErrorBT']}
                        onChange={event =>
                          ValidatePhoneNumber(event.target.value)
                        }
                        sx={inputSx}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <FieldLabel label='Email' />
                      <TextField
                        disabled={!checkCarrierPermissionsLevel4()}
                        value={thirdPatyAccDetails.emailAddress}
                        fullWidth
                        size='small'
                        type='email'
                        error={Boolean(validationErrors['emailErrorBT'])}
                        helperText={validationErrors['emailErrorBT']}
                        onChange={e => ValidateEmailAddress(e.target.value)}
                        sx={inputSx}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <FieldLabel label='City' />
                      <TextField
                        disabled={!checkCarrierPermissionsLevel4()}
                        value={thirdPatyAccDetails.city}
                        fullWidth
                        size='small'
                        onChange={e =>
                          setThirdPatyAccDetails({
                            ...thirdPatyAccDetails,
                            city: e.target.value
                          })
                        }
                        sx={inputSx}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <FieldLabel label='State' />
                      <TextField
                        disabled={!checkCarrierPermissionsLevel4()}
                        value={thirdPatyAccDetails.state}
                        fullWidth
                        size='small'
                        onChange={e =>
                          setThirdPatyAccDetails({
                            ...thirdPatyAccDetails,
                            state: e.target.value
                          })
                        }
                        sx={inputSx}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <FieldLabel label='Postal Code' />
                      <TextField
                        disabled={!checkCarrierPermissionsLevel4()}
                        value={thirdPatyAccDetails.postalCode}
                        fullWidth
                        size='small'
                        type='number'
                        onChange={e =>
                          setThirdPatyAccDetails({
                            ...thirdPatyAccDetails,
                            postalCode: e.target.value
                          })
                        }
                        sx={inputSx}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <FieldLabel label='Country Code' />
                      <TextField
                        disabled={!checkCarrierPermissionsLevel4()}
                        value={thirdPatyAccDetails.countryCode}
                        fullWidth
                        size='small'
                        onChange={e =>
                          setThirdPatyAccDetails({
                            ...thirdPatyAccDetails,
                            countryCode: e.target.value
                          })
                        }
                        sx={inputSx}
                      />
                    </Grid>
                  </Grid>
                </Box>

                {/* Claims Section */}
                <Box sx={sidebarStyles.sectionCard}>
                  <Typography
                    sx={{
                      fontSize: 13,
                      fontWeight: 700,
                      color: '#0f3d2e',
                      mb: 2,
                      pb: 1,
                      borderBottom: '2px solid #cceee3',
                      display: 'inline-block'
                    }}
                  >
                    Claims Settings
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <FieldLabel label='Contact Name' required />
                      <TextField
                        fullWidth
                        size='small'
                        value={claimSettingsObj.contactName}
                        onChange={e => {
                          handleClaimSettingsChange(
                            'contactName',
                            e.target.value
                          );
                          setErrors(prev => ({ ...prev, contactName: '' }));
                        }}
                        error={!!errors.contactName}
                        helperText={errors.contactName}
                        sx={inputSx}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FieldLabel label='Contact Email' required />
                      <TextField
                        fullWidth
                        size='small'
                        value={claimSettingsObj.contactEmail}
                        onChange={e =>
                          handleClaimSettingsChange(
                            'contactEmail',
                            e.target.value
                          )
                        }
                        error={!!errors.contactEmail}
                        helperText={errors.contactEmail}
                        sx={inputSx}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FieldLabel label='Contact Phone' required />
                      <TextField
                        fullWidth
                        inputProps={{ maxLength: 14 }}
                        size='small'
                        value={formatPhoneNumber(claimSettingsObj.contactPhone)}
                        onChange={e =>
                          handleClaimSettingsChange(
                            'contactPhone',
                            formatPhoneNumber(e.target.value)
                          )
                        }
                        error={!!errors.contactPhone}
                        helperText={errors.contactPhone}
                        sx={inputSx}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FieldLabel label='Copy To (CC)' />
                      <TextField
                        fullWidth
                        size='small'
                        value={claimSettingsObj.copyTo}
                        onChange={e =>
                          handleClaimSettingsChange('copyTo', e.target.value)
                        }
                        sx={inputSx}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </>
            )}

            {/* ── RATES (single section) ── */}
            {sidebarSection === 'rates' && (
              <Box sx={sidebarStyles.sectionCard}>
                <Typography
                  sx={{
                    fontSize: 13,
                    fontWeight: 700,
                    color: '#0f3d2e',
                    mb: 2,
                    pb: 1,
                    borderBottom: '2px solid #cceee3',
                    display: 'inline-block'
                  }}
                >
                  Rate Quote Settings
                </Typography>
                <Grid container spacing={2}>
                  {/* Row 1 */}
                  <Grid item xs={12}>
                    <Typography
                      sx={{
                        fontSize: 12,
                        fontWeight: 600,
                        color: '#475569',
                        mb: 1
                      }}
                    >
                      Primary Shipment Rule
                    </Typography>
                  </Grid>
                  {secondPaymentTerms !== 'Both' && (
                    <>
                      <Grid
                        item
                        xs={rateQuoteUIhandler(ratesType, 'xs')}
                        sm={rateQuoteUIhandler(ratesType, 'sm')}
                        md={rateQuoteUIhandler(ratesType, 'md')}
                        lg={rateQuoteUIhandler(ratesType, 'lg')}
                        xl={rateQuoteUIhandler(ratesType, 'xl')}
                      >
                        <FormControl fullWidth size='small'>
                          <FieldLabel label='Shipment Type' />
                          <Select
                            disabled={!checkCarrierPermissions()}
                            fullWidth
                            value={paymentTerms}
                            onChange={e => {
                              setPaymentTerms(e.target.value);
                              e.target.value === 'Inbound'
                                ? setSecondPaymentTerms('OutBound')
                                : setSecondPaymentTerms('Inbound');
                            }}
                            sx={inputSx}
                          >
                            <MenuItem value={'Inbound'}>Inbound</MenuItem>
                            <MenuItem value={'OutBound'}>OutBound</MenuItem>
                            <MenuItem value={'Both'}>Both</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      {selectedTab.current == 3 &&
                        configuredCarrierName === 'UPS' && (
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={ratesType === 'Guaranteed' ? 3 : 4}
                            lg={ratesType === 'Guaranteed' ? 3 : 4}
                            xl={ratesType === 'Guaranteed' ? 3 : 4}
                          >
                            <FormControl fullWidth size='small'>
                              <FieldLabel label='Service Type' />
                              <Select
                                disabled={!checkCarrierPermissions()}
                                fullWidth
                                value={parcelServiceType}
                                onChange={e =>
                                  setParcelServiceType(e.target.value)
                                }
                                sx={inputSx}
                              >
                                <MenuItem value={'All'}>All</MenuItem>
                                <MenuItem value={'UPS Next Day Air Early'}>
                                  UPS Next Day Air Early
                                </MenuItem>
                                <MenuItem value={'UPS Next Day Air'}>
                                  UPS Next Day Air
                                </MenuItem>
                                <MenuItem value={'UPS Ground'}>
                                  UPS Ground
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>
                        )}
                      {configuredCarrierName === 'FedEx' &&
                        selectedTab.current != 3 && (
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={ratesType === 'Guaranteed' ? 3 : 4}
                            lg={ratesType === 'Guaranteed' ? 3 : 4}
                            xl={ratesType === 'Guaranteed' ? 3 : 4}
                          >
                            <FormControl fullWidth size='small'>
                              <FieldLabel label='Service Type' />
                              <Select
                                disabled={!checkCarrierPermissions()}
                                fullWidth
                                value={LTLServiceType}
                                onChange={e =>
                                  setLTLServiceType(e.target.value)
                                }
                                sx={inputSx}
                              >
                                <MenuItem value={'All'}>All</MenuItem>
                                <MenuItem value={'Economy'}>Economy</MenuItem>
                                <MenuItem value={'Priority'}>Priority</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>
                        )}
                      <Grid
                        item
                        xs={rateQuoteUIhandler(ratesType, 'xs')}
                        sm={rateQuoteUIhandler(ratesType, 'sm')}
                        md={rateQuoteUIhandler(ratesType, 'md')}
                        lg={rateQuoteUIhandler(ratesType, 'lg')}
                        xl={rateQuoteUIhandler(ratesType, 'xl')}
                      >
                        <FormControl fullWidth size='small'>
                          <FieldLabel label='Rates Type' />
                          <Select
                            disabled={!checkCarrierPermissions()}
                            fullWidth
                            value={ratesType}
                            onChange={e => {
                              setGuaranteedType('All');
                              setRatesType(e.target.value);
                            }}
                            sx={inputSx}
                          >
                            <MenuItem value={'All'}>All</MenuItem>
                            <MenuItem value={'Standard'}>Standard</MenuItem>
                            <MenuItem value={'Guaranteed'}>Guaranteed</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      {ratesType === 'Guaranteed' && (
                        <Grid
                          item
                          xs={rateQuoteUIhandler(ratesType, 'xs')}
                          sm={rateQuoteUIhandler(ratesType, 'sm')}
                          md={rateQuoteUIhandler(ratesType, 'md')}
                          lg={rateQuoteUIhandler(ratesType, 'lg')}
                          xl={rateQuoteUIhandler(ratesType, 'xl')}
                        >
                          <FormControl fullWidth size='small'>
                            <FieldLabel label='Guaranteed Filter' />
                            <Select
                              disabled={!checkCarrierPermissions()}
                              fullWidth
                              value={guaranteedType}
                              onChange={e => setGuaranteedType(e.target.value)}
                              sx={inputSx}
                            >
                              <MenuItem value={'All'}>All</MenuItem>
                              <MenuItem value={'Quickest'}>
                                Quickest Delivery
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                      )}
                    </>
                  )}

                  {/* Row 2 - secondary rule */}
                  {paymentTerms !== 'Both' && (
                    <>
                      <Grid item xs={12}>
                        <Divider sx={{ my: 0.5 }} />
                        <Typography
                          sx={{
                            fontSize: 12,
                            fontWeight: 600,
                            color: '#475569',
                            mt: 1
                          }}
                        >
                          Secondary Shipment Rule
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={rateQuoteUIhandler(secondRatesType, 'xs')}
                        sm={rateQuoteUIhandler(secondRatesType, 'sm')}
                        md={rateQuoteUIhandler(secondRatesType, 'md')}
                        lg={rateQuoteUIhandler(secondRatesType, 'lg')}
                        xl={rateQuoteUIhandler(secondRatesType, 'xl')}
                      >
                        <FormControl fullWidth size='small'>
                          <FieldLabel label='Shipment Type' />
                          <Select
                            disabled={!checkCarrierPermissions()}
                            fullWidth
                            value={secondPaymentTerms}
                            onChange={e => {
                              setSecondPaymentTerms(e.target.value);
                              e.target.value === 'Inbound'
                                ? setPaymentTerms('OutBound')
                                : setPaymentTerms('Inbound');
                            }}
                            sx={inputSx}
                          >
                            <MenuItem value={'OutBound'}>OutBound</MenuItem>
                            <MenuItem value={'Inbound'}>Inbound</MenuItem>
                            <MenuItem value={'Both'}>Both</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      {selectedTab.current == 3 &&
                        configuredCarrierName === 'UPS' && (
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={secondRatesType === 'Guaranteed' ? 3 : 4}
                            lg={secondRatesType === 'Guaranteed' ? 3 : 4}
                            xl={secondRatesType === 'Guaranteed' ? 3 : 4}
                          >
                            <FormControl fullWidth size='small'>
                              <FieldLabel label='Service Type' />
                              <Select
                                disabled={!checkCarrierPermissions()}
                                fullWidth
                                value={secondParcelServiceType}
                                onChange={e =>
                                  setSecondParcelServiceType(e.target.value)
                                }
                                sx={inputSx}
                              >
                                <MenuItem value={'All'}>All</MenuItem>
                                <MenuItem value={'UPS Next Day Air Early'}>
                                  UPS Next Day Air Early
                                </MenuItem>
                                <MenuItem value={'UPS Next Day Air'}>
                                  UPS Next Day Air
                                </MenuItem>
                                <MenuItem value={'UPS Ground'}>
                                  UPS Ground
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>
                        )}
                      {configuredCarrierName === 'FedEx' &&
                        selectedTab.current != 3 && (
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={secondRatesType === 'Guaranteed' ? 3 : 4}
                            lg={secondRatesType === 'Guaranteed' ? 3 : 4}
                            xl={secondRatesType === 'Guaranteed' ? 3 : 4}
                          >
                            <FormControl fullWidth size='small'>
                              <FieldLabel label='Service Type' />
                              <Select
                                disabled={!checkCarrierPermissions()}
                                fullWidth
                                value={secondLTLServiceType}
                                onChange={e =>
                                  setSecondLTLServiceType(e.target.value)
                                }
                                sx={inputSx}
                              >
                                <MenuItem value={'All'}>All</MenuItem>
                                <MenuItem value={'Economy'}>Economy</MenuItem>
                                <MenuItem value={'Priority'}>Priority</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>
                        )}
                      <Grid
                        item
                        xs={rateQuoteUIhandler(secondRatesType, 'xs')}
                        sm={rateQuoteUIhandler(secondRatesType, 'sm')}
                        md={rateQuoteUIhandler(secondRatesType, 'md')}
                        lg={rateQuoteUIhandler(secondRatesType, 'lg')}
                        xl={rateQuoteUIhandler(secondRatesType, 'xl')}
                      >
                        <FormControl fullWidth size='small'>
                          <FieldLabel label='Rates Type' />
                          <Select
                            disabled={!checkCarrierPermissions()}
                            fullWidth
                            value={secondRatesType}
                            onChange={e => {
                              setSecondGuaranteedType('All');
                              setSecondRatesType(e.target.value);
                            }}
                            sx={inputSx}
                          >
                            <MenuItem value={'All'}>All</MenuItem>
                            <MenuItem value={'Standard'}>Standard</MenuItem>
                            <MenuItem value={'Guaranteed'}>Guaranteed</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      {secondRatesType === 'Guaranteed' && (
                        <Grid
                          item
                          xs={rateQuoteUIhandler(secondRatesType, 'xs')}
                          sm={rateQuoteUIhandler(secondRatesType, 'sm')}
                          md={rateQuoteUIhandler(secondRatesType, 'md')}
                          lg={rateQuoteUIhandler(secondRatesType, 'lg')}
                          xl={rateQuoteUIhandler(secondRatesType, 'xl')}
                        >
                          <FormControl fullWidth size='small'>
                            <FieldLabel label='Guaranteed Filter' />
                            <Select
                              disabled={!checkCarrierPermissions()}
                              fullWidth
                              value={secondGuaranteedType}
                              onChange={e =>
                                setSecondGuaranteedType(e.target.value)
                              }
                              sx={inputSx}
                            >
                              <MenuItem value={'All'}>All</MenuItem>
                              <MenuItem value={'Quickest'}>
                                Quickest Delivery
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                      )}
                    </>
                  )}
                </Grid>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    );
  };

  const CarrierCard = ({ items, selected, onSelect, selectedTab }) => {
    const { consumed, remaining, total, progress } = useMemo(() => {
      const totals = items?.proNumberTotals;
      const left = items?.proNumberLeft;
      const totalsNum = totals ? Number(totals) : 0;
      const leftNum = left ? Number(left) : 0;
      const consumedValue =
        !isNaN(totalsNum) && !isNaN(leftNum) ? totalsNum - leftNum : 0;
      const remainingValue = !isNaN(leftNum) ? leftNum : 0;
      const totalValue = consumedValue + remainingValue;
      const progressValue =
        totalValue > 0 ? (consumedValue / totalValue) * 100 : 0;
      return {
        consumed: consumedValue,
        remaining: remainingValue,
        total: totalValue,
        progress: progressValue
      };
    }, [items?.proNumberTotals, items?.proNumberLeft]);

    return (
      <Card
        variant='outlined'
        onClick={onSelect}
        sx={{
          p: 1.5,
          mb: 2,
          borderRadius: 2,
          width: '100%',
          minHeight: '190px',
          mx: 'auto',
          transition: 'all 0.11s ease',
          background: selected ? '#f8f9ff' : '#fff',
          border: selected ? '1.3px solid #5a4bfa' : '1px solid #ddd',
          boxShadow: selected
            ? '0 0 12px rgba(109,93,251,0.25)'
            : '0 1px 3px rgba(0,0,0,0.1)',
          '&:hover': {
            boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
            cursor: 'pointer'
          },
          minWidth: '280px'
        }}
      >
        <Grid container alignItems='center' spacing={1}>
          <Grid item xs={12} sm='auto' textAlign={{ xs: 'center', sm: 'left' }}>
            <Avatar
              variant='circular'
              alt={items.name}
              src={base_logo_url + items.logo}
              sx={{
                width: { xs: 40, sm: 60 },
                height: { xs: 40, sm: 60 },
                mx: { xs: 'auto', sm: 0 },
                p: '2px',
                background: 'linear-gradient(135deg, #6D5DFB, #46C8FF)',
                '& img': {
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  borderRadius: '50%',
                  backgroundColor: '#fff',
                  padding: 0
                }
              }}
            />
          </Grid>
          {items.cType === 'TL' ? (
            <Grid item xs>
              <Box flexWrap='wrap' gap={2} sx={{ minHeight: '32px' }}>
                <Typography fontWeight={700} fontSize='0.95rem' noWrap>
                  {items.name}
                </Typography>
                <Tooltip arrow placement='top' title={items.contactEmail}>
                  <Typography
                    variant='body2'
                    fontWeight={400}
                    fontSize='0.85rem'
                    noWrap
                  >
                    {items.contactEmail?.split(',')[0].trim()}
                  </Typography>
                </Tooltip>
              </Box>
            </Grid>
          ) : (
            <Grid item xs>
              <Box
                display='flex'
                justifyContent='space-between'
                alignItems='center'
                flexWrap='wrap'
              >
                <Typography fontWeight={700} fontSize='0.95rem' noWrap>
                  E-Pros
                </Typography>
                <Box display='flex' alignItems='center' gap={1}>
                  <Tooltip arrow placement='top' title='Total PRO'>
                    <Box
                      display='flex'
                      alignItems='center'
                      gap={0.5}
                      sx={{
                        padding: '2px 8px',
                        borderRadius: '12px',
                        backgroundColor: 'rgba(25,118,210,0.1)',
                        border: '1px solid rgba(25,118,210,0.2)'
                      }}
                    >
                      <NumbersIcon
                        sx={{ fontSize: '0.9rem', color: '#1976d2' }}
                      />
                      <Typography
                        variant='body2'
                        fontWeight={600}
                        fontSize='0.85rem'
                        noWrap
                      >
                        {total}
                      </Typography>
                    </Box>
                  </Tooltip>
                  <Tooltip arrow placement='top' title='Consumed PRO'>
                    <Box
                      display='flex'
                      alignItems='center'
                      gap={0.5}
                      sx={{
                        padding: '2px 8px',
                        borderRadius: '12px',
                        backgroundColor: 'rgba(244,67,54,0.1)',
                        border: '1px solid rgba(244,67,54,0.2)'
                      }}
                    >
                      <RemoveCircleOutlineIcon
                        sx={{ fontSize: '0.9rem', color: '#f44336' }}
                      />
                      <Typography
                        variant='body2'
                        fontWeight={600}
                        fontSize='0.85rem'
                        noWrap
                      >
                        {consumed}
                      </Typography>
                    </Box>
                  </Tooltip>
                  <Tooltip arrow placement='top' title='Remaining PRO'>
                    <Box
                      display='flex'
                      alignItems='center'
                      gap={0.5}
                      sx={{
                        padding: '2px 8px',
                        borderRadius: '12px',
                        backgroundColor: 'rgba(76,175,80,0.1)',
                        border: '1px solid rgba(76,175,80,0.2)'
                      }}
                    >
                      <CheckCircleOutlineIcon
                        sx={{ fontSize: '0.9rem', color: '#4caf50' }}
                      />
                      <Typography
                        variant='body2'
                        fontWeight={600}
                        fontSize='0.85rem'
                        noWrap
                      >
                        {remaining}
                      </Typography>
                    </Box>
                  </Tooltip>
                </Box>
              </Box>
              <LinearProgress
                variant='determinate'
                value={progress}
                sx={{
                  height: 6,
                  my: 1,
                  borderRadius: 4,
                  backgroundColor: '#e0e0e0',
                  '& .MuiLinearProgress-bar': { backgroundColor: '#2196f3' }
                }}
              />
              <Grid
                display={'flex'}
                justifyContent='space-between'
                spacing={0}
                sx={{ mt: 1.5, gap: 1 }}
              >
                <Grid>
                  <Box
                    display='flex'
                    alignItems='center'
                    gap={0.5}
                    flexWrap='wrap'
                  >
                    <Tooltip arrow placement='top' title='Third Party Account'>
                      <Typography
                        variant='body2'
                        fontWeight={600}
                        fontSize='0.85rem'
                        noWrap
                      >
                        3PA#:
                      </Typography>
                    </Tooltip>
                    <Typography
                      variant='body2'
                      fontWeight={400}
                      fontSize='0.85rem'
                      noWrap
                    >
                      {items.thirdPartyAccountNumber || 'N/A'}
                    </Typography>
                  </Box>
                </Grid>
                <Grid>
                  <Tooltip
                    title={items.surchargeApplyOn || 'N/A'}
                    arrow
                    placement='top'
                  >
                    <Box
                      display='flex'
                      alignItems='center'
                      gap={0.5}
                      flexWrap='wrap'
                      justifyContent='flex-end'
                    >
                      <Typography
                        variant='body2'
                        fontWeight={600}
                        fontSize='0.85rem'
                        noWrap
                      >
                        Surcharge:
                      </Typography>
                      <Typography
                        variant='body2'
                        fontWeight={400}
                        fontSize='0.85rem'
                        noWrap
                      >
                        {items.surcharge || '0'}
                        {items.surchargeType || '$'}
                      </Typography>
                    </Box>
                  </Tooltip>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
        <Divider sx={{ my: 1, borderBottomWidth: 2, opacity: 0.3 }} />
        {/* Card footer content unchanged - keeping same as original for brevity */}
        {items.cType === 'TL' ? (
          <Box sx={{ flexWrap: 'wrap' }}>
            <Typography
              variant='subtitle2'
              fontWeight='bold'
              fontSize='0.9rem'
              gutterBottom
              noWrap
            >
              Subtype
            </Typography>
            <Box display='flex' flexWrap='wrap' alignItems='center' gap={1}>
              {items.cSubType
                ?.split(',')
                .map(type => type.trim())
                .filter(Boolean)
                .map((type, index) => (
                  <Box key={index} display='flex' alignItems='center' gap={0.5}>
                    <Checkbox
                      disabled
                      size='small'
                      checked
                      sx={{
                        padding: '4px',
                        color: 'green',
                        '&.Mui-checked': { color: 'green' },
                        '& .MuiSvgIcon-root': {
                          fontSize: '1.1rem',
                          backgroundColor: 'white',
                          borderRadius: '3px'
                        }
                      }}
                    />
                    <Typography variant='body2' fontSize='0.85rem' noWrap>
                      {type}
                    </Typography>
                  </Box>
                ))}
            </Box>
          </Box>
        ) : (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              p: 1,
              border: '1px solid #e0e0e0',
              borderRadius: 1,
              backgroundColor: '#f5f5f5'
            }}
          >
            <Typography
              variant='body2'
              fontSize='0.75rem'
              color='text.secondary'
            >
              {items.rqSettingType} → {items.rqSettingTypeInfo}
              {items.rqSettingTypeFilter
                ? ` → ${items.rqSettingTypeFilter}`
                : ''}
            </Typography>
            {items.rqSettingType2 && (
              <Typography
                variant='body2'
                fontSize='0.75rem'
                color='text.secondary'
              >
                {items.rqSettingType2} → {items.rqSettingTypeInfo2}
                {items.rqSettingTypeFilter2
                  ? ` → ${items.rqSettingTypeFilter2}`
                  : ''}
              </Typography>
            )}
          </Box>
        )}
      </Card>
    );
  };

  return (
    <Box
      className={carriersLoader ? 'Box_Loader' : isMobile ? '' : 'Box_Parent'}
    >
      <MetaTags>
        <title>
          {base_url === 'https://beta.api.shiptechpro.com/'
            ? 'Carriers | Shiptechpro'
            : 'Carriers | TMS Shipping'}
        </title>
      </MetaTags>
      <ToastContainer
        style={
          isMobile
            ? { width: '100%', display: 'flex', justifyContent: 'center' }
            : { width: 'auto' }
        }
        position='top-center'
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <Grid>
        {/* ── E-Pro Generate Dialog (unchanged) ── */}
        <Dialog
          PaperProps={{
            style: {
              minWidth: '60vw',
              height:
                Boolean(eproSeriesDataGenerate?.length) ||
                loadingEproSeriesGenerate
                  ? '70vh'
                  : 'auto'
            }
          }}
          className='InnerDialog'
          open={openEProDialogGenerate}
          onClose={handleCloseEProSeriesDialogGenerate}
        >
          <DialogTitle>{configuredCarrierName} E-Pro Series</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Grid
                className='h-100 w-100'
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                {Boolean(eproSeriesDataGenerate?.length) ||
                loadingEproSeriesGenerate ? (
                  <Grid sx={{ display: 'flex', flexDirection: 'column' }}>
                    <MaterialReactTable
                      data={eproSeriesDataGenerate}
                      columns={eproSeriesColumnsGenerate}
                      enableStickyHeader
                      enablePagination={false}
                      initialState={{ density: 'compact' }}
                      muiTableContainerProps={{
                        sx: {
                          minWidth: '58vw',
                          maxWidth: '58vw',
                          maxHeight: '43vh',
                          minHeight: '43vh',
                          overflow: 'scroll'
                        }
                      }}
                      state={{ isLoading: loadingEproSeriesGenerate }}
                      muiBottomToolbarProps={{
                        style: { minHeight: 5, maxHeight: 5 }
                      }}
                    />
                  </Grid>
                ) : (
                  <Alert className='w-100' severity='error'>
                    {eProSeriesGenerateError}
                  </Alert>
                )}
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              size='small'
              variant='outlined'
              color='error'
              onClick={handleCloseEProSeriesDialogGenerate}
            >
              Close
            </Button>
            {Boolean(eproSeriesDataGenerate?.length) && (
              <Button
                disabled={
                  !(
                    (userPermissionsArr &&
                      (userPermissionsArr.filter(p => p.level3).length ||
                        userPermissionsArr.filter(p => p.level4).length)) ||
                    UserIsAdmin
                  )
                }
                size='small'
                variant='contained'
                color='info'
                onClick={handleImportEProSeriesDialog}
              >
                Import
              </Button>
            )}
          </DialogActions>
        </Dialog>

        {/* ── E-Pro View Dialog (unchanged) ── */}
        <Dialog
          PaperProps={{ style: { minWidth: '60vw', height: '70vh' } }}
          className='InnerDialog'
          open={openEProDialog}
          onClose={handleCloseEProSeriesDialog}
        >
          <DialogTitle>{configuredCarrierName} E-Pro Series</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Grid sx={{ display: 'flex', justifyContent: 'center' }}>
                <MaterialReactTable
                  data={eproSeriesData}
                  columns={eproSeriesColumns}
                  enableStickyHeader
                  enablePagination={false}
                  initialState={{ density: 'compact' }}
                  muiTableContainerProps={{
                    sx: {
                      minWidth: '58vw',
                      maxWidth: '58vw',
                      maxHeight: '43vh',
                      minHeight: '43vh',
                      overflow: 'scroll'
                    }
                  }}
                  state={{ isLoading: loadingEproSeries }}
                  muiBottomToolbarProps={{
                    style: { minHeight: 5, maxHeight: 5 }
                  }}
                />
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              size='small'
              variant='outlined'
              color='error'
              onClick={handleCloseEProSeriesDialog}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* ── NEW DRAWER (replaces Dialog) ── */}
        <Drawer
          anchor='right'
          open={drawerOpen && !isNewUI}
          onClose={handleCloseDrawer}
          PaperProps={{
            sx: {
              width: {
                xs: '100%',
                sm: '90vw',
                md: '80vw',
                lg: '75vw',
                xl: '80vw'
              },
              maxWidth: '1000px',
              height: '100vh',
              overflow: 'hidden',
              borderRadius: { xs: 0, sm: '16px 0 0 16px' }
            }
          }}
        >
          {/* Drawer header */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              px: 2.5,
              py: 1.5,
              background: '#fff',
              borderBottom: '1px solid #cceee3'
            }}
          >
            <Typography
              sx={{ color: '#0f3d2e', fontSize: 14, fontWeight: 700 }}
            >
              Configure {configuredCarrierName} Settings
            </Typography>
            <IconButton
              size='small'
              onClick={handleCloseDrawer}
              sx={{
                color: '#6dc4a8',
                '&:hover': { color: '#1d9e75', background: '#e1f4ee' }
              }}
            >
              <svg
                width='14'
                height='14'
                viewBox='0 0 24 24'
                fill='none'
                stroke='currentColor'
                strokeWidth='2.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              >
                <line x1='18' y1='6' x2='6' y2='18' />
                <line x1='6' y1='6' x2='18' y2='18' />
              </svg>
            </IconButton>
          </Box>

          <Box sx={{ flex: 1, overflow: 'hidden', display: 'flex' }}>
            {DrawerSettingsContent()}
          </Box>

          <Box
            sx={{
              px: 2,
              mr: 7,
              py: 1.2,
              borderTop: '1px solid #cceee3',
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 2,
              background: '#f0faf6'
            }}
          >
            <Button
              size='small'
              variant='outlined'
              onClick={handleCloseDrawer}
              sx={{
                borderRadius: '8px',
                borderColor: '#9dddc8',
                color: '#1d9e75',
                '&:hover': { borderColor: '#1d9e75', background: '#e1f4ee' }
              }}
            >
              Cancel
            </Button>
            <Button
              disabled={!checkCarrierPermissionsLevel4()}
              size='small'
              variant='contained'
              onClick={handleSidebarSave}
              sx={{
                borderRadius: '8px',
                px: 3,
                background: '#1d9e75',
                '&:hover': { background: '#178a64' }
              }}
              autoFocus
            >
              Save Changes
            </Button>
          </Box>
        </Drawer>

        {/* ── Confirm Pro Number Dialog (unchanged) ── */}
        <Dialog
          PaperProps={{ style: { minWidth: '28vw', height: '47vh' } }}
          className='InnerDialog'
          open={openConfirmDialog}
          onClose={handleConfirmDialogClose}
        >
          <DialogTitle>Confirmation Dialog</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Grid sx={{ display: 'flex', justifyContent: 'space-around' }}>
                Changes are un-revertible until it reached to the minimum Alert
                Level
              </Grid>
              <Grid sx={{ display: 'flex', justifyContent: 'center' }}>
                <Grid sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Grid sx={{ mt: 1 }} container spacing={0}>
                    <Grid item xs={6}>
                      <FieldLabel label='From' />
                      <TextField
                        InputLabelProps={{
                          style: { color: 'black', fontSize: 18 }
                        }}
                        disabled
                        InputProps={{ disableUnderline: true }}
                        variant='standard'
                        required
                        error={Boolean(proNumberErrors['proNumberFrom'])}
                        helperText={proNumberErrors['proNumberFrom']}
                        fullWidth
                        size='small'
                        value={
                          proNumberSuffixPosition === 'Pre'
                            ? proNumberSuffixValue + proNumberFrom
                            : proNumberFrom + proNumberSuffixValue
                        }
                        sx={inputSx}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <FieldLabel label='To' />
                      <TextField
                        InputLabelProps={{
                          style: { color: 'black', fontSize: 18 }
                        }}
                        disabled
                        InputProps={{ disableUnderline: true }}
                        variant='standard'
                        required
                        error={Boolean(proNumberErrors['proNumberFrom'])}
                        helperText={proNumberErrors['proNumberFrom']}
                        sx={{ ...inputSx }}
                        fullWidth
                        size='small'
                        value={
                          proNumberSuffixPosition === 'Pre'
                            ? proNumberSuffixValue + proNumberTo
                            : proNumberTo + proNumberSuffixValue
                        }
                      />
                    </Grid>
                  </Grid>
                  <Grid sx={{ mt: 0 }} container spacing={1}>
                    <Grid item xs={12}>
                      <FieldLabel label='Minimum pro-number for Alert' />
                      <TextField
                        InputLabelProps={{
                          style: { color: 'black', fontSize: 18 }
                        }}
                        disabled
                        InputProps={{ disableUnderline: true }}
                        variant='standard'
                        required
                        inputProps={{ min: 1, max: proNumberTo }}
                        fullWidth
                        size='small'
                        value={proNumberAlert}
                        sx={inputSx}
                      />
                    </Grid>
                  </Grid>
                  {proNumberTo && (
                    <Grid sx={{ mt: 0 }} container spacing={1}>
                      <Grid item xs={6}>
                        <FieldLabel label='Total Pro-Numbers' />
                        <TextField
                          disabled
                          InputProps={{ disableUnderline: true }}
                          variant='standard'
                          fullWidth
                          size='small'
                          value={
                            !proNmbChanged && proNumberTotals
                              ? proNumberTotals
                              : handleRemainingPro()
                          }
                          sx={inputSx}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <FieldLabel label='Remaining Pro-Numbers' />
                        <TextField
                          disabled
                          InputProps={{ disableUnderline: true }}
                          variant='standard'
                          fullWidth
                          size='small'
                          value={
                            !proNmbChanged && proNumberLeft !== null
                              ? proNumberLeft
                              : handleRemainingPro()
                          }
                          sx={inputSx}
                        />
                      </Grid>
                    </Grid>
                  )}
                  {email && (
                    <>
                      <FieldLabel label='Emails for Alert' />
                      <TextField
                        disabled
                        InputProps={{ disableUnderline: true }}
                        variant='standard'
                        fullWidth
                        size='small'
                        multiline
                        value={
                          email.length > 40 || email.split(',').length > 3
                            ? email.split(',').join('\n')
                            : email
                        }
                        sx={inputSx}
                      />
                    </>
                  )}
                </Grid>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              size='small'
              variant='outlined'
              onClick={handleConfirmDialogClose}
            >
              No
            </Button>
            <Button
              size='small'
              variant='contained'
              color='success'
              onClick={handleUpdateCarrierRequest}
              autoFocus
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>

        {/* ── Import Confirm Dialog (unchanged) ── */}
        <Dialog
          PaperProps={{ style: { minWidth: '28vw', height: 'auto' } }}
          className='InnerDialog'
          open={openConfirmDialogImport}
          onClose={handleConfirmDialogCloseImport}
        >
          <DialogTitle>Confirmation Dialog</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Grid sx={{ display: 'flex', justifyContent: 'space-around' }}>
                Are you sure to import {eproSeriesDataGenerate?.length} numbers
                of E-Pro Series?
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              size='small'
              variant='outlined'
              onClick={handleConfirmDialogCloseImport}
            >
              No
            </Button>
            <Button
              size='small'
              variant='contained'
              color='success'
              onClick={handleImportEProSeries}
              autoFocus
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>

      {/* ── MAIN CONTENT AREA (unchanged structure) ── */}
      <Grid container sx={{ m: 0 }}>
        {carriersLoader ? (
          <CircularProgress />
        ) : isNewUI ? (
          <Grid
            container
            spacing={2}
            sx={{
              height: { xs: 'calc(100vh - 100px)', md: 'calc(100vh - 125px)' },
              minHeight: '100%'
            }}
          >
            <Grid
              container
              spacing={2}
              sx={{
                height: {
                  xs: 'calc(100vh - 100px)',
                  md: 'calc(100vh - 125px)'
                },
                minHeight: '100%'
              }}
            >
              {!listView && (
                <Grid item md={3.5} lg={3.5} xl={3.5}>
                  <Card
                    sx={{
                      borderRadius: '16px',
                      boxShadow: 3,
                      p: 2,
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column'
                    }}
                  >
                    <Tabs
                      value={selectedTab.current}
                      onChange={handleTabChange}
                      variant='fullWidth'
                      textColor='primary'
                      indicatorColor='primary'
                      sx={{
                        minHeight: 36,
                        '& .MuiTab-root': {
                          textTransform: 'none',
                          fontWeight: 500,
                          fontSize: '0.75rem',
                          minHeight: 36,
                          padding: '6px 12px',
                          minWidth: 'auto'
                        }
                      }}
                    >
                      <Tab value={1} label='LTL' />
                      <Tab value={2} label='TL' />
                      <Tab value={3} label='Parcel' />
                    </Tabs>
                    <Box sx={{ mt: 2 }}>
                      <TextField
                        fullWidth
                        placeholder='Search...'
                        size='small'
                        variant='outlined'
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                        InputProps={{
                          endAdornment: searchTerm && (
                            <InputAdornment position='end'>
                              <IconButton
                                size='small'
                                onClick={() => setSearchTerm('')}
                              >
                                <ClearIcon fontSize='small' />
                              </IconButton>
                            </InputAdornment>
                          )
                        }}
                        sx={inputSx}
                      />
                    </Box>
                    <Box sx={{ mx: 1, my: 1 }}>
                      <Box
                        display='flex'
                        alignItems='center'
                        justifyContent='space-between'
                      >
                        <Typography variant='subtitle2' fontWeight='bold'>
                          Sort:
                        </Typography>
                        <Box display='flex' alignItems='center' gap={0.5}>
                          {[
                            { key: 'name', label: 'Name', icon: <SortIcon /> },
                            {
                              key: 'total',
                              label: 'Total',
                              icon: (
                                <NumbersIcon
                                  sx={{ fontSize: '1rem', color: '#1976d2' }}
                                />
                              )
                            },
                            {
                              key: 'consumed',
                              label: 'Consumed',
                              icon: (
                                <RemoveCircleOutlineIcon
                                  sx={{ fontSize: '1rem', color: '#f44336' }}
                                />
                              )
                            },
                            {
                              key: 'remaining',
                              label: 'Remaining',
                              icon: (
                                <CheckCircleOutlineIcon
                                  sx={{ fontSize: '1rem', color: '#4caf50' }}
                                />
                              )
                            },
                            {
                              key: 'surcharge',
                              label: 'Surcharge',
                              icon: <AttachMoneyIcon fontSize='small' />
                            }
                          ]
                            .filter(item =>
                              selectedTab.current == 2
                                ? item.key === 'name'
                                : true
                            )
                            .map(item => (
                              <Tooltip
                                key={item.key}
                                title={`Sort by ${item.label}`}
                              >
                                <IconButton
                                  size='small'
                                  onClick={() => handleSort(item.key)}
                                  color={
                                    sortBy === item.key ? 'primary' : 'default'
                                  }
                                  sx={{
                                    border:
                                      sortBy === item.key
                                        ? '1px solid'
                                        : 'none',
                                    borderColor: 'primary.main'
                                  }}
                                >
                                  {item.icon}
                                </IconButton>
                              </Tooltip>
                            ))}
                          {sortBy && (
                            <Tooltip
                              title={
                                sortOrder === 'asc' ? 'Descending' : 'Ascending'
                              }
                            >
                              <IconButton
                                size='small'
                                onClick={() =>
                                  setSortOrder(
                                    sortOrder === 'asc' ? 'desc' : 'asc'
                                  )
                                }
                                color='primary'
                              >
                                {sortOrder === 'asc' ? (
                                  <ArrowUpwardIcon fontSize='small' />
                                ) : (
                                  <ArrowDownwardIcon fontSize='small' />
                                )}
                              </IconButton>
                            </Tooltip>
                          )}
                        </Box>
                      </Box>
                    </Box>
                    <Grid sx={{ maxHeight: '80%', overflow: 'auto', p: 1 }}>
                      {filteredCarriers.map((items, index) => (
                        <CarrierCard
                          key={index}
                          items={items}
                          selected={selectedCarrier?.current?.id === items.id}
                          onSelect={() => {
                            setListView(false);
                            setShowEditMode(false);
                            handleCloseDrawer();
                            selectedCarrier.current = items;
                            handleUpdateCarrier('', items, 'kanbanView');
                            forceUpdate();
                          }}
                          selectedTab={selectedTab.current}
                        />
                      ))}
                    </Grid>
                    <Box sx={{ flexGrow: 1 }} />
                  </Card>
                </Grid>
              )}

              <Grid
                item
                md={!listView ? 8.5 : 12}
                lg={!listView ? 8.5 : 12}
                xl={!listView ? 8.5 : 12}
              >
                {!listView ? (
                  <Card
                    sx={{
                      borderRadius: '16px',
                      boxShadow: 3,
                      p: 2,
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'end'
                    }}
                  >
                    {selectedTab?.current == '2' ? (
                      <Box
                        sx={{
                          pt: 1,
                          overflow: 'auto',
                          height: {
                            xs: 'calc(100vh - 100px)',
                            md: 'calc(100vh - 180px)'
                          },
                          minHeight: '100%'
                        }}
                      >
                        <CreateCarrier
                          key={selectedCarrier?.current?.id}
                          state={selectedCarrier?.current}
                          action={'NewUI'}
                          fetchCarriers={fetchCarriers}
                          handleCloseTLView={handleBackToList}
                        />
                      </Box>
                    ) : showEditMode ? (
                      // Drawer for isNewUI edit mode - using Drawer component
                      <Drawer
                        anchor='right'
                        open={showEditMode}
                        onClose={() => setShowEditMode(false)}
                        PaperProps={{
                          sx: {
                            width: {
                              xs: '100%',
                              sm: '90vw',
                              md: '80vw',
                              lg: '70vw'
                            },
                            maxWidth: '1000px',
                            height: '100vh',
                            overflow: 'hidden',
                            borderRadius: { xs: 0, sm: '16px 0 0 16px' }
                          }
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            px: 2.5,
                            py: 1.5,
                            background: '#fff',
                            borderBottom: '1px solid #cceee3'
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#0f3d2e',
                              fontSize: 14,
                              fontWeight: 700
                            }}
                          >
                            Configure {configuredCarrierName} Settings
                          </Typography>
                          <IconButton
                            size='small'
                            onClick={() => setShowEditMode(false)}
                            sx={{
                              color: '#6dc4a8',
                              '&:hover': {
                                color: '#1d9e75',
                                background: '#e1f4ee'
                              }
                            }}
                          >
                            <svg
                              width='14'
                              height='14'
                              viewBox='0 0 24 24'
                              fill='none'
                              stroke='currentColor'
                              strokeWidth='2.5'
                              strokeLinecap='round'
                              strokeLinejoin='round'
                            >
                              <line x1='18' y1='6' x2='6' y2='18' />
                              <line x1='6' y1='6' x2='18' y2='18' />
                            </svg>
                          </IconButton>
                        </Box>
                        <Box
                          sx={{ flex: 1, overflow: 'hidden', display: 'flex' }}
                        >
                          {DrawerSettingsContent()}
                        </Box>
                        <Box
                          sx={{
                            px: 2,
                            py: 1.2,
                            borderTop: '1px solid #cceee3',
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: 2,
                            background: '#f0faf6'
                          }}
                        >
                          <Button
                            size='small'
                            variant='outlined'
                            onClick={() => setShowEditMode(false)}
                            sx={{
                              borderRadius: '8px',
                              borderColor: '#9dddc8',
                              color: '#1d9e75',
                              '&:hover': {
                                borderColor: '#1d9e75',
                                background: '#e1f4ee'
                              }
                            }}
                          >
                            Cancel
                          </Button>
                          <Button
                            disabled={!checkCarrierPermissionsLevel4()}
                            size='small'
                            variant='contained'
                            onClick={handleSidebarSave}
                            sx={{
                              borderRadius: '8px',
                              px: 3,
                              background: '#1d9e75',
                              '&:hover': { background: '#178a64' }
                            }}
                          >
                            Save Changes
                          </Button>
                        </Box>
                      </Drawer>
                    ) : (
                      <CarrierReadOnlyView
                        carrier={selectedCarrier.current}
                        onEdit={() => setShowEditMode(true)}
                        fetchCarriers={fetchCarriers}
                      />
                    )}

                    <CardActions
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        pt: 1.5
                      }}
                    >
                      {selectedTab.current == 2 && (
                        <Grid
                          sx={{
                            position: 'fixed',
                            top: '10.5%',
                            left: '35vw',
                            zIndex: 1000
                          }}
                        >
                          <Button
                            size={isMobile ? 'small' : 'medium'}
                            onClick={e => {
                              selectedTab.current = 2;
                              setListView(false);
                              handleCreateCarrier(e);
                              forceUpdate();
                            }}
                            style={
                              isMobile
                                ? {
                                    fontSize: 10,
                                    color: '#3361FF',
                                    backgroundColor: '#E4F3FD'
                                  }
                                : {
                                    color: '#3361FF',
                                    fontSize: 11,
                                    backgroundColor: '#E4F3FD'
                                  }
                            }
                            variant='contained'
                          >
                            Add Carrier
                            <svg
                              className='ms-2'
                              width='11'
                              height='10'
                              viewBox='0 0 11 10'
                              fill='none'
                              xmlns='http://www.w3.org/2000/svg'
                            >
                              <path
                                d='M4.94531 9.72396V5.72396H0.945312V4.39062H4.94531V0.390625H6.27865V4.39062H10.2786V5.72396H6.27865V9.72396H4.94531Z'
                                fill='#3361FF'
                              />
                            </svg>
                          </Button>
                        </Grid>
                      )}
                      <Button
                        size='small'
                        variant='outlined'
                        onClick={e => {
                          handleBackToList(e);
                        }}
                        sx={{ borderRadius: '8px' }}
                      >
                        Back to List
                      </Button>
                      {selectedTab.current !== 2 && showEditMode && (
                        <Button
                          disabled={
                            !(
                              (userPermissionsArr &&
                                userPermissionsArr.filter(p => p.level4)
                                  .length) ||
                              UserIsAdmin
                            )
                          }
                          size='small'
                          variant='contained'
                          onClick={handleSidebarSave}
                          sx={{
                            borderRadius: '8px',
                            px: 3,
                            background: '#1d9e75',
                            '&:hover': { background: '#178a64' }
                          }}
                          autoFocus
                        >
                          Save Changes
                        </Button>
                      )}
                    </CardActions>
                  </Card>
                ) : (
                  <Card
                    sx={{
                      borderRadius: '16px',
                      boxShadow: 3,
                      p: 2,
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column'
                    }}
                  >
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                      <Chip
                        size='small'
                        variant='outlined'
                        label={
                          <FormControlLabel
                            control={
                              <Switch
                                checked={isNewUI}
                                onChange={handleToggle}
                                color='primary'
                                size='small'
                              />
                            }
                            label={isNewUI ? 'New UI' : 'Old UI'}
                            sx={{ ml: 1 }}
                          />
                        }
                        sx={{
                          borderColor: '#1976d2',
                          color: '#1976d2',
                          p: 1,
                          backgroundColor: 'white'
                        }}
                      />
                    </Box>
                    <Grid
                      container
                      spacing={2}
                      sx={{ flex: 1, overflow: 'auto' }}
                    >
                      <Grid item xs={12} md={4}>
                        <Typography
                          variant='subtitle2'
                          fontWeight={600}
                          sx={{ mb: 1, color: 'primary.main' }}
                        >
                          LTL Carriers
                        </Typography>
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2
                          }}
                        >
                          {LTLCarriers.map((items, index) => (
                            <CarrierCard
                              key={index}
                              items={items}
                              selected={false}
                              onSelect={() => {
                                selectedTab.current = 1;
                                selectedCarrier.current = items;
                                handleUpdateCarrier('', items, 'kanbanView');
                                forceUpdate();
                              }}
                              selectedTab={selectedTab.current}
                            />
                          ))}
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Typography
                          variant='subtitle2'
                          fontWeight={600}
                          sx={{ mb: 1, color: 'primary.main' }}
                        >
                          Parcel Carriers
                        </Typography>
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2
                          }}
                        >
                          {parcelCarriers.map((items, index) => (
                            <CarrierCard
                              key={index}
                              items={items}
                              selected={false}
                              onSelect={() => {
                                selectedTab.current = 3;
                                selectedCarrier.current = items;
                                handleUpdateCarrier('', items, 'kanbanView');
                                forceUpdate();
                              }}
                              selectedTab={selectedTab.current}
                            />
                          ))}
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Typography
                          variant='subtitle2'
                          fontWeight={600}
                          sx={{ mb: 1, color: 'primary.main' }}
                        >
                          TL Carriers
                        </Typography>
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2
                          }}
                        >
                          {TLcarriers.length > 0 ? (
                            TLcarriers.map((items, index) => (
                              <CarrierCard
                                key={index}
                                items={items}
                                selected={false}
                                onSelect={() => {
                                  selectedTab.current = 2;
                                  selectedCarrier.current = items;
                                  handleUpdateCarrier('', items, 'kanbanView');
                                  forceUpdate();
                                }}
                                selectedTab={selectedTab.current}
                              />
                            ))
                          ) : (
                            <Button
                              size={isMobile ? 'small' : 'medium'}
                              onClick={e => {
                                selectedTab.current = 2;
                                setListView(false);
                                handleCreateCarrier(e);
                                forceUpdate();
                              }}
                              style={
                                isMobile
                                  ? {
                                      fontSize: 10,
                                      color: '#3361FF',
                                      backgroundColor: '#E4F3FD'
                                    }
                                  : {
                                      color: '#3361FF',
                                      fontSize: 11,
                                      backgroundColor: '#E4F3FD'
                                    }
                              }
                              variant='contained'
                            >
                              Add Carrier
                              <svg
                                className='ms-2'
                                width='11'
                                height='10'
                                viewBox='0 0 11 10'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <path
                                  d='M4.94531 9.72396V5.72396H0.945312V4.39062H4.94531V0.390625H6.27865V4.39062H10.2786V5.72396H6.27865V9.72396H4.94531Z'
                                  fill='#3361FF'
                                />
                              </svg>
                            </Button>
                          )}
                        </Box>
                      </Grid>
                    </Grid>
                  </Card>
                )}
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <Grid
            xs={12}
            md={12}
            sm={12}
            lg={12}
            xl={12}
            sx={{ backgroundColor: '#fff', p: 0 }}
          >
            <TabContext value={selectedTab.current}>
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: 'divider',
                  p: 0,
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <TabList
                  value={selectedTab.current}
                  onChange={(e, newValue) => handleChange(e, newValue)}
                  aria-label='carrier tabs'
                >
                  {activeCarriers.map(carrier => (
                    <Tab
                      key={carrier.value}
                      label={carrier.permissionName.replace(' Carriers', '')}
                      value={carrier.value}
                    />
                  ))}
                </TabList>
                <Box>
                  <Chip
                    size='small'
                    variant='outlined'
                    label={
                      <FormControlLabel
                        control={
                          <Switch
                            checked={isNewUI}
                            onChange={handleToggle}
                            color='primary'
                            size='small'
                          />
                        }
                        label={isNewUI ? 'New UI' : 'Old UI'}
                        sx={{ ml: 1 }}
                      />
                    }
                    sx={{
                      borderColor: '#1976d2',
                      color: '#1976d2',
                      p: 1,
                      backgroundColor: 'white'
                    }}
                  />
                </Box>
              </Box>
              <TabPanel
                sx={isMobile ? { m: -2 } : {}}
                value={selectedTab.current}
              >
                {userPermissionsArr !== null && (
                  <MaterialReactTable
                    columns={columnsData}
                    data={
                      selectedTab.current == 1
                        ? LTLCarriers
                        : selectedTab.current == 2
                          ? TLcarriers
                          : parcelCarriers
                    }
                    enableRowSelection={row => row.original.active}
                    muiTableBodyRowProps={({ row }) => {
                      const isDisabled = !row.original.active && value != '2';
                      return {
                        sx: {
                          backgroundColor: isDisabled
                            ? 'rgba(0,0,0,0.02)'
                            : undefined,
                          '&:hover': {
                            backgroundColor: isDisabled
                              ? 'rgba(0,0,0,0.02) !important'
                              : undefined
                          },
                          opacity: isDisabled ? 0.7 : 1,
                          cursor: isDisabled ? 'not-allowed' : 'pointer',
                          '& td': {
                            color: isDisabled ? 'text.disabled' : 'inherit',
                            '& .MuiIconButton-root': {
                              pointerEvents: isDisabled ? 'none' : 'auto',
                              opacity: isDisabled ? 0.5 : 1
                            }
                          }
                        },
                        title: isDisabled
                          ? 'This carrier is disabled by admin'
                          : undefined
                      };
                    }}
                    enableStickyHeader
                    muiTableHeadCellFilterTextFieldProps={{ placeholder: '' }}
                    muiTableContainerProps={{
                      sx: isMobile
                        ? { maxHeight: '66vh', minHeight: '66vh' }
                        : {
                            maxHeight: '60vh',
                            minHeight: '55vh',
                            overflow: 'auto'
                          }
                    }}
                    positionToolbarAlertBanner='bottom'
                    initialState={{ density: 'compact' }}
                    renderToolbarInternalActions={({ table }) => (
                      <div>
                        <MRT_ToggleGlobalFilterButton
                          table={table}
                          title='Search'
                        />
                        <MRT_ToggleFiltersButton
                          table={table}
                          title='Filters'
                        />
                        <MRT_ToggleDensePaddingButton
                          table={table}
                          title='Spacing'
                        />
                        <MRT_ShowHideColumnsButton
                          table={table}
                          title='Show/Hide Columns'
                        />
                        <MRT_FullScreenToggleButton
                          table={table}
                          title='Fullscreen'
                        />
                        <Tooltip title='Clear All Filters' arrow>
                          <IconButton
                            onClick={() => {
                              table.resetColumnFilters(true);
                              table.setShowColumnFilters(false);
                            }}
                          >
                            <FilterAltOffIcon />
                          </IconButton>
                        </Tooltip>
                      </div>
                    )}
                    renderDetailPanel={
                      selectedTab.current !== 1
                        ? false
                        : ({ row }) => {
                            const eprostatus = carrierProSeriesStatus.filter(
                              cps => cps.carrierId === row.original.carrierId
                            );
                            if (eprostatus.length === 0)
                              return (
                                <div className='d-flex justify-content-center'>
                                  <Typography className='text-danger'>
                                    Data regarding E-Pro series not found for
                                    this carrier.
                                  </Typography>
                                </div>
                              );
                            return (
                              <Box>
                                <Row>
                                  <Col lg={12} xl={12} className='px-4'>
                                    <TableContainer
                                      sx={{ width: '100%' }}
                                      component={Paper}
                                    >
                                      <Table sx={{ width: '100%' }}>
                                        <TableHead>
                                          <TableRow>
                                            <TableCell
                                              sx={{ fontWeight: 'bold' }}
                                              align='left'
                                            >
                                              Location
                                            </TableCell>
                                            {Array.from({ length: 16 }).map(
                                              (_, i) => (
                                                <TableCell
                                                  key={i}
                                                  align='left'
                                                />
                                              )
                                            )}
                                            <TableCell
                                              sx={{ fontWeight: 'bold' }}
                                              align='left'
                                            >
                                              ProNumber Series
                                            </TableCell>
                                            <TableCell align='left' />
                                            <TableCell
                                              sx={{ fontWeight: 'bold' }}
                                              align='left'
                                            >
                                              Total ProNumbers
                                            </TableCell>
                                            <TableCell align='left' />
                                            <TableCell
                                              sx={{ fontWeight: 'bold' }}
                                              align='left'
                                            >
                                              Consumed ProNumbers
                                            </TableCell>
                                            <TableCell align='left' />
                                            <TableCell
                                              sx={{ fontWeight: 'bold' }}
                                              align='left'
                                            >
                                              Remaining ProNumbers
                                            </TableCell>
                                            <TableCell align='left' />
                                          </TableRow>
                                        </TableHead>
                                        <TableBody>
                                          {eprostatus.map((prst, index) => (
                                            <TableRow
                                              key={index}
                                              sx={{
                                                '&:hover': {
                                                  backgroundColor: '#f5f5f5',
                                                  cursor: 'pointer'
                                                }
                                              }}
                                            >
                                              <TableCell align='left'>
                                                {prst.locationName}
                                              </TableCell>
                                              {Array.from({ length: 16 }).map(
                                                (_, i) => (
                                                  <TableCell
                                                    key={i}
                                                    align='left'
                                                  />
                                                )
                                              )}
                                              <TableCell align='center'>
                                                {prst.proNumberStart &&
                                                prst.proNumberEnd
                                                  ? `${prst.proNumberStart} - ${prst.proNumberEnd}`
                                                  : '-'}
                                              </TableCell>
                                              <TableCell align='left' />
                                              <TableCell align='left'>
                                                {prst.proNumberTotals}
                                              </TableCell>
                                              <TableCell align='left' />
                                              <TableCell align='left'>
                                                {prst.proNumberTotals &&
                                                  prst.proNumberLeft &&
                                                  calculateConsumed(
                                                    prst.proNumberTotals,
                                                    prst.proNumberLeft
                                                  )}
                                              </TableCell>
                                              <TableCell align='left' />
                                              <TableCell align='left'>
                                                {prst.proNumberLeft}
                                              </TableCell>
                                              <TableCell align='left' />
                                            </TableRow>
                                          ))}
                                        </TableBody>
                                      </Table>
                                    </TableContainer>
                                  </Col>
                                </Row>
                              </Box>
                            );
                          }
                    }
                    renderTopToolbarCustomActions={({ table }) => {
                      if (
                        selectedTab.current == 2 &&
                        ((userPermissionsArr &&
                          userPermissionsArr.filter(
                            p => p.permissionName === 'TL Carriers' && p.level3
                          ).length) ||
                          UserIsAdmin)
                      ) {
                        return (
                          <Button
                            size={isMobile ? 'small' : 'medium'}
                            onClick={() => {
                              setCreateUpdateCarrier(true);
                              history.push('/create-carrier');
                            }}
                            className='m-2'
                            style={
                              isMobile
                                ? {
                                    fontSize: 10,
                                    color: '#3361FF',
                                    backgroundColor: '#E4F3FD'
                                  }
                                : {
                                    color: '#3361FF',
                                    backgroundColor: '#E4F3FD'
                                  }
                            }
                            variant='contained'
                          >
                            Add Carrier
                            <svg
                              className='ms-2'
                              width='11'
                              height='10'
                              viewBox='0 0 11 10'
                              fill='none'
                              xmlns='http://www.w3.org/2000/svg'
                            >
                              <path
                                d='M4.94531 9.72396V5.72396H0.945312V4.39062H4.94531V0.390625H6.27865V4.39062H10.2786V5.72396H6.27865V9.72396H4.94531Z'
                                fill='#3361FF'
                              />
                            </svg>
                          </Button>
                        );
                      }
                    }}
                    renderRowActions
                  />
                )}
              </TabPanel>
            </TabContext>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}

export default Carriers;
